// src/constants/msessage-kind.ts
var MESSAGE_IFRAME_CONTAINER_STYLE = "usertour:iframe:container:style";
var MESSAGE_SELECTOR_SWITCH = "usertour:selector:switch";
var MESSAGE_SELECTOR_OUTPUT = "usertour:selector:output";
var MESSAGE_MEASURE_LISTENER = "usertour:measure:listener";
var MESSAGE_MEASURE_INSTALL = "usertour:measure:install";
var MESSAGE_APPLICATION_STARTED = "usertour:application:started";
var MESSAGE_APPLICATION_RUN = "usertour:application:run";
var MESSAGE_APPLICATION_INIT = "usertour:application:init";
var MESSAGE_APPLICATION_CLOSE = "usertour:application:close";
var MESSAGE_APPLICATION_EXIT = "usertour:application:exit";
var MESSAGE_APPLICATION_INIT_SUCCESS = "usertour:application:init:success";
var MESSAGE_ELEMENT_SELECT_SUCCESS = "usertour:element:select:success";
var MESSAGE_CONTENT_PREVIEW = "usertour:content:preview";
var MESSAGE_CONTENT_PREVIEW_SUCCESS = "usertour:content:preview:success";
var MESSAGE_CRX_OPEN_TARGET = "usertour:crxOpenTarget";
var MESSAGE_CRX_OPEN_NEW_TARGET = "usertour:crxOpenNewTarget";
var MESSAGE_CRX_SEND_PROXY = "usertour:crxSendProxyMessage";
var MESSAGE_START_FLOW_WITH_TOKEN = "usertour:startFlowWithToken";
var MESSAGE_SDK_INIT = "usertour:init";
var MESSAGE_CRX_OPEN_TARGET_REPLY = "usertour:crxOpenTargetReply";
var MESSAGE_CRX_PING = "usertour:crxPing";
var MESSAGE_CRX_PONG = "usertour:crxPong";

// src/constants/colors.ts
var TAILWINDCSS_COLORS = {
  slate: {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a",
    950: "#020617"
  },
  gray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
    950: "#030712"
  },
  zinc: {
    50: "#fafafa",
    100: "#f4f4f5",
    200: "#e4e4e7",
    300: "#d4d4d8",
    400: "#a1a1aa",
    500: "#71717a",
    600: "#52525b",
    700: "#3f3f46",
    800: "#27272a",
    900: "#18181b",
    950: "#09090b"
  },
  neutral: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#e5e5e5",
    300: "#d4d4d4",
    400: "#a3a3a3",
    500: "#737373",
    600: "#525252",
    700: "#404040",
    800: "#262626",
    900: "#171717",
    950: "#0a0a0a"
  },
  stone: {
    50: "#fafaf9",
    100: "#f5f5f4",
    200: "#e7e5e4",
    300: "#d6d3d1",
    400: "#a8a29e",
    500: "#78716c",
    600: "#57534e",
    700: "#44403c",
    800: "#292524",
    900: "#1c1917",
    950: "#0c0a09"
  },
  red: {
    50: "#fef2f2",
    100: "#fee2e2",
    200: "#fecaca",
    300: "#fca5a5",
    400: "#f87171",
    500: "#ef4444",
    600: "#dc2626",
    700: "#b91c1c",
    800: "#991b1b",
    900: "#7f1d1d",
    950: "#450a0a"
  },
  orange: {
    50: "#fff7ed",
    100: "#ffedd5",
    200: "#fed7aa",
    300: "#fdba74",
    400: "#fb923c",
    500: "#f97316",
    600: "#ea580c",
    700: "#c2410c",
    800: "#9a3412",
    900: "#7c2d12",
    950: "#431407"
  },
  amber: {
    50: "#fffbeb",
    100: "#fef3c7",
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    500: "#f59e0b",
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
    900: "#78350f",
    950: "#451a03"
  },
  yellow: {
    50: "#fefce8",
    100: "#fef9c3",
    200: "#fef08a",
    300: "#fde047",
    400: "#facc15",
    500: "#eab308",
    600: "#ca8a04",
    700: "#a16207",
    800: "#854d0e",
    900: "#713f12",
    950: "#422006"
  },
  lime: {
    50: "#f7fee7",
    100: "#ecfccb",
    200: "#d9f99d",
    300: "#bef264",
    400: "#a3e635",
    500: "#84cc16",
    600: "#65a30d",
    700: "#4d7c0f",
    800: "#3f6212",
    900: "#365314",
    950: "#1a2e05"
  },
  green: {
    50: "#f0fdf4",
    100: "#dcfce7",
    200: "#bbf7d0",
    300: "#86efac",
    400: "#4ade80",
    500: "#22c55e",
    600: "#16a34a",
    700: "#15803d",
    800: "#166534",
    900: "#14532d",
    950: "#052e16"
  },
  emerald: {
    50: "#ecfdf5",
    100: "#d1fae5",
    200: "#a7f3d0",
    300: "#6ee7b7",
    400: "#34d399",
    500: "#10b981",
    600: "#059669",
    700: "#047857",
    800: "#065f46",
    900: "#064e3b",
    950: "#022c22"
  },
  teal: {
    50: "#f0fdfa",
    100: "#ccfbf1",
    200: "#99f6e4",
    300: "#5eead4",
    400: "#2dd4bf",
    500: "#14b8a6",
    600: "#0d9488",
    700: "#0f766e",
    800: "#115e59",
    900: "#134e4a",
    950: "#042f2e"
  },
  cyan: {
    50: "#ecfeff",
    100: "#cffafe",
    200: "#a5f3fc",
    300: "#67e8f9",
    400: "#22d3ee",
    500: "#06b6d4",
    600: "#0891b2",
    700: "#0e7490",
    800: "#155e75",
    900: "#164e63",
    950: "#083344"
  },
  sky: {
    50: "#f0f9ff",
    100: "#e0f2fe",
    200: "#bae6fd",
    300: "#7dd3fc",
    400: "#38bdf8",
    500: "#0ea5e9",
    600: "#0284c7",
    700: "#0369a1",
    800: "#075985",
    900: "#0c4a6e",
    950: "#082f49"
  },
  blue: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a",
    950: "#172554"
  },
  indigo: {
    50: "#eef2ff",
    100: "#e0e7ff",
    200: "#c7d2fe",
    300: "#a5b4fc",
    400: "#818cf8",
    500: "#6366f1",
    600: "#4f46e5",
    700: "#4338ca",
    800: "#3730a3",
    900: "#312e81",
    950: "#1e1b4b"
  },
  violet: {
    50: "#f5f3ff",
    100: "#ede9fe",
    200: "#ddd6fe",
    300: "#c4b5fd",
    400: "#a78bfa",
    500: "#8b5cf6",
    600: "#7c3aed",
    700: "#6d28d9",
    800: "#5b21b6",
    900: "#4c1d95",
    950: "#2e1065"
  },
  purple: {
    50: "#faf5ff",
    100: "#f3e8ff",
    200: "#e9d5ff",
    300: "#d8b4fe",
    400: "#c084fc",
    500: "#a855f7",
    600: "#9333ea",
    700: "#7e22ce",
    800: "#6b21a8",
    900: "#581c87",
    950: "#3b0764"
  },
  fuchsia: {
    50: "#fdf4ff",
    100: "#fae8ff",
    200: "#f5d0fe",
    300: "#f0abfc",
    400: "#e879f9",
    500: "#d946ef",
    600: "#c026d3",
    700: "#a21caf",
    800: "#86198f",
    900: "#701a75",
    950: "#4a044e"
  },
  pink: {
    50: "#fdf2f8",
    100: "#fce7f3",
    200: "#fbcfe8",
    300: "#f9a8d4",
    400: "#f472b6",
    500: "#ec4899",
    600: "#db2777",
    700: "#be185d",
    800: "#9d174d",
    900: "#831843",
    950: "#500724"
  },
  rose: {
    50: "#fff1f2",
    100: "#ffe4e6",
    200: "#fecdd3",
    300: "#fda4af",
    400: "#fb7185",
    500: "#f43f5e",
    600: "#e11d48",
    700: "#be123c",
    800: "#9f1239",
    900: "#881337",
    950: "#4c0519"
  }
};

// src/constants/zindex.ts
var BUILDER_Z = {
  canvas: 10900,
  // preview widget on the canvas
  // A backdropped tooltip lifts its surface to canvas+1 to sit above its backdrop
  // curtain (which masks the preview at the canvas layer). Unlike modal/bubble —
  // which drop to the page base layer so the editor overlays float above them —
  // the tooltip can't, since its curtain is anchored to the canvas. So its
  // in-canvas editor overlays (validation error tooltip, action popover) take a
  // band just above the lifted surface. Kept below `panel` so the sidebar wins.
  canvasOverlay: 10905,
  panel: 11e3,
  // floating sidebar / inspector panels
  popover: 11001,
  // selects / popovers opened from a panel
  rulesDialog: 11002,
  // rules sub-dialog
  rules: 11003,
  // condition / action rule editors
  previewDialog: 11100
  // top-level preview dialog
};
var EDITOR_OVERLAY = 10901;
var EDITOR_SELECT = 10902;
var EDITOR_SIDEBAR = 10903;
var EDITOR_RICH_TOOLBAR = 10904;
var EDITOR_RICH_TOOLBAR_MORE = 10905;
var EDITOR_RICH_ACTION = 10906;
var EDITOR_RICH_ACTION_CONTENT = 10907;
var PREVIEW_BASIC = 1;
var WidgetZIndex = /* @__PURE__ */ ((WidgetZIndex2) => {
  WidgetZIndex2[WidgetZIndex2["BASE"] = 1e6] = "BASE";
  WidgetZIndex2[WidgetZIndex2["TOUR_OFFSET"] = 200] = "TOUR_OFFSET";
  WidgetZIndex2[WidgetZIndex2["RESOURCE_CENTER_OFFSET"] = 150] = "RESOURCE_CENTER_OFFSET";
  WidgetZIndex2[WidgetZIndex2["CHECKLIST_OFFSET"] = 100] = "CHECKLIST_OFFSET";
  WidgetZIndex2[WidgetZIndex2["LAUNCHER_OFFSET"] = 0] = "LAUNCHER_OFFSET";
  return WidgetZIndex2;
})(WidgetZIndex || {});
var RulesZIndexOffset = /* @__PURE__ */ ((RulesZIndexOffset2) => {
  RulesZIndexOffset2[RulesZIndexOffset2["POPOVER"] = 0] = "POPOVER";
  RulesZIndexOffset2[RulesZIndexOffset2["DROPDOWN"] = 0] = "DROPDOWN";
  RulesZIndexOffset2[RulesZIndexOffset2["COMBOBOX"] = 0] = "COMBOBOX";
  RulesZIndexOffset2[RulesZIndexOffset2["ERROR"] = 1] = "ERROR";
  return RulesZIndexOffset2;
})(RulesZIndexOffset || {});
var WebZIndex = /* @__PURE__ */ ((WebZIndex2) => {
  WebZIndex2[WebZIndex2["RULES"] = 50] = "RULES";
  return WebZIndex2;
})(WebZIndex || {});

// src/constants/storage.ts
var StorageKeys = /* @__PURE__ */ ((StorageKeys2) => {
  StorageKeys2["IDENTIFY_ANONYMOUS"] = "identify-anonymous";
  StorageKeys2["CHECKLIST_EXPANDED"] = "checklist-expanded";
  StorageKeys2["RESOURCE_CENTER_EXPANDED"] = "resource-center-expanded";
  StorageKeys2["RESOURCE_CENTER_NAV"] = "resource-center-nav";
  StorageKeys2["ENVIRONMENT_ID"] = "environment-id";
  StorageKeys2["COLOR_PICKER_RECENT"] = "color-picker-recent";
  StorageKeys2["THEME_BUILDER_LEFT_SIDEBAR_WIDTH"] = "theme-builder-left-sidebar-width";
  StorageKeys2["THEME_BUILDER_RIGHT_SIDEBAR_WIDTH"] = "theme-builder-right-sidebar-width";
  return StorageKeys2;
})(StorageKeys || {});

// src/constants/locate.ts
var locates = [
  { locale: "sq-AL", name: "Albanian (Albania)" },
  { locale: "ar", name: "Arabic" },
  { locale: "bs-BA", name: "Bosnian (Bosnia)" },
  { locale: "bg-BG", name: "Bulgarian (Bulgaria)" },
  { locale: "zh-CN", name: "Chinese (Simplified, People's Republic of China)" },
  { locale: "zh-TW", name: "Chinese, Mandarin (Traditional, Taiwan)" },
  { locale: "hr-HR", name: "Croatian (Croatia)" },
  { locale: "cs-CZ", name: "Czech (Czech Republic)" },
  { locale: "da-DK", name: "Danish (Denmark)" },
  { locale: "nl-BE", name: "Dutch (Belgium)" },
  { locale: "nl-NL", name: "Dutch (Netherlands)" },
  { locale: "en-GB", name: "English (UK)" },
  { locale: "en-US", name: "English (US)" },
  { locale: "et-EE", name: "Estonian (Estonia)" },
  { locale: "fi-FI", name: "Finnish (Finland)" },
  { locale: "fr-FR", name: "French (France)" },
  { locale: "fr-BE", name: "French (Belgium)" },
  { locale: "de-DE", name: "German (Germany)" },
  { locale: "el-GR", name: "Greek (Greece)" },
  { locale: "he-IL", name: "Hebrew (Israel)" },
  { locale: "hi-IN", name: "Hindi (India)" },
  { locale: "hu-HU", name: "Hungarian (Hungary)" },
  { locale: "is-IS", name: "Icelandic (Iceland)" },
  { locale: "id-ID", name: "Indonesian (Indonesia)" },
  { locale: "it-IT", name: "Italian (Italy)" },
  { locale: "ja-JP", name: "Japanese (Japan)" },
  { locale: "ko-KR", name: "Korean (Korea)" },
  { locale: "lv-LV", name: "Latvian (Latvia)" },
  { locale: "lt-LT", name: "Lithuanian (Lithuania)" },
  { locale: "nb-NO", name: "Norwegian Bokm\xE5l (Norway)" },
  { locale: "pl-PL", name: "Polish (Poland)" },
  { locale: "pt-BR", name: "Portuguese (Brazil)" },
  { locale: "pt-PT", name: "Portuguese (Portugal)" },
  { locale: "ro-RO", name: "Romanian (Romania)" },
  { locale: "ru-RU", name: "Russian (Russia)" },
  { locale: "sk-SK", name: "Slovak (Slovakia)" },
  { locale: "sl-SI", name: "Slovenian (Slovenia)" },
  { locale: "es-AR", name: "Spanish (Argentina)" },
  { locale: "es-CL", name: "Spanish (Chile)" },
  { locale: "es-CO", name: "Spanish (Colombia)" },
  { locale: "es-MX", name: "Spanish (Mexico)" },
  { locale: "es-ES", name: "Spanish (Spain)" },
  { locale: "sv-SE", name: "Swedish (Sweden)" },
  { locale: "tg-TJ", name: "Tajik (Tajikistan)" },
  { locale: "th-TH", name: "Thai (Thailand)" },
  { locale: "tr-TR", name: "Turkish (Turkey)" },
  { locale: "uk-UA", name: "Ukrainian (Ukraine)" },
  { locale: "vi-VN", name: "Vietnamese (Vietnam)" }
];

// src/constants/localization.ts
var MACHINE_TRANSLATION_UNITS_PER_BATCH = 40;

// src/constants/cookie.ts
var ACCESS_TOKEN_COOKIE = "_ut_access";
var REFRESH_TOKEN_COOKIE = "_ut_refresh";
var UID_COOKIE = "_ut_uid";

// src/constants/billing.ts
import { PlanType } from "@usertour/types";
var HobbySessionLimit = 5e3;
var ProSessionLimit = 5e4;
var GrowthSessionLimit = 1e5;
var BusinessSessionLimit = 2e5;
var HOBBY = {
  removeBranding: false,
  customCss: false,
  auditLogs: false,
  auditLogRetentionDays: 0,
  ssoSaml: false,
  ssoOidc: false,
  webhooks: false,
  integrations: false,
  crmIntegrations: false,
  sessionsLimit: HobbySessionLimit,
  teamMemberLimit: 1,
  environmentLimit: 1,
  dataRetentionYears: 1,
  apiRateLimit: 100
};
var STARTER = {
  ...HOBBY,
  removeBranding: true,
  // Outbound webhooks and integrations unlock with the first paid tier.
  webhooks: true,
  integrations: true,
  sessionsLimit: ProSessionLimit,
  teamMemberLimit: 3,
  environmentLimit: 2,
  dataRetentionYears: 3,
  apiRateLimit: 500
};
var GROWTH = {
  ...STARTER,
  removeBranding: true,
  customCss: true,
  // Growth can view the audit log, but only a recent window; Business is full.
  auditLogs: true,
  auditLogRetentionDays: 7,
  // CRM sync (ADR 0013) unlocks one tier above the analytics providers.
  crmIntegrations: true,
  sessionsLimit: GrowthSessionLimit,
  teamMemberLimit: 10,
  environmentLimit: 3,
  dataRetentionYears: 5,
  apiRateLimit: 1e3
};
var BUSINESS = {
  ...GROWTH,
  auditLogs: true,
  auditLogRetentionDays: "unlimited",
  ssoSaml: true,
  ssoOidc: true,
  sessionsLimit: BusinessSessionLimit,
  teamMemberLimit: "unlimited",
  environmentLimit: "unlimited",
  dataRetentionYears: 7,
  apiRateLimit: 3e3
};
var ENTERPRISE = { ...BUSINESS };
var PLAN_FEATURES = {
  [PlanType.HOBBY]: HOBBY,
  [PlanType.STARTER]: STARTER,
  [PlanType.GROWTH]: GROWTH,
  [PlanType.BUSINESS]: BUSINESS,
  [PlanType.ENTERPRISE]: ENTERPRISE
};

// src/constants/sdk.ts
import { contentEndReason, contentStartReason } from "@usertour/types";
var SDKClientEvents = /* @__PURE__ */ ((SDKClientEvents2) => {
  SDKClientEvents2["DOM_LOADED"] = "dom-loaded";
  SDKClientEvents2["CSS_LOADED"] = "css-loaded";
  SDKClientEvents2["CSS_LOADED_FAILED"] = "css-loaded-failed";
  SDKClientEvents2["CONTAINER_CREATED"] = "container-created";
  SDKClientEvents2["COMPONENT_CLOSED"] = "component-closed";
  SDKClientEvents2["CONTENT_STARTED"] = "content-started";
  SDKClientEvents2["CONTENT_CHANGED"] = "content-changed";
  SDKClientEvents2["CHECKLIST_EXPANDED_CHANGE"] = "checklist-expanded-change";
  SDKClientEvents2["CHECKLIST_FIRST_SEEN"] = "checklist-first-seen";
  SDKClientEvents2["ELEMENT_FOUND"] = "element-found";
  SDKClientEvents2["ELEMENT_FOUND_TIMEOUT"] = "element-found-timeout";
  SDKClientEvents2["ELEMENT_CHANGED"] = "element-changed";
  SDKClientEvents2["SERVER_MESSAGE_SUCCEEDED"] = "server-message:succeeded";
  SDKClientEvents2["SERVER_MESSAGE_FAILED"] = "server-message:failed";
  SDKClientEvents2["EVENT_REPORTED"] = "event-reported";
  SDKClientEvents2["USER_IDENTIFIED_SUCCEEDED"] = "user-identified-succeeded";
  SDKClientEvents2["CONDITION_STATE_CHANGED"] = "condition-state-changed";
  SDKClientEvents2["WAIT_TIMER_STATE_CHANGED"] = "wait-timer-state-changed";
  SDKClientEvents2["URL_CHANGED"] = "url-changed";
  SDKClientEvents2["INITIALIZATION_COMPLETE"] = "initialization-complete";
  SDKClientEvents2["INITIALIZATION_FAILED"] = "initialization-failed";
  return SDKClientEvents2;
})(SDKClientEvents || {});
var WEBSOCKET_NAMESPACES_V2 = "/v2";
var flowReasonTitleMap = {
  // Start reasons
  [contentStartReason.START_FROM_CONDITION]: "Matched auto-start condition",
  [contentStartReason.START_FROM_URL]: "Started from URL",
  [contentStartReason.START_FROM_SESSION]: "Started from session",
  [contentStartReason.START_FROM_PROGRAM]: "Started from program",
  [contentStartReason.START_FROM_CONTENT_ID]: "Started from content id",
  [contentStartReason.START_FROM_MANUAL]: "Manually started",
  [contentStartReason.START_FROM_ACTION]: "Button clicked",
  // End reasons (existing)
  [contentEndReason.USER_CLOSED]: "User dismissed flow",
  [contentEndReason.ACTION]: "Ended by action in this flow",
  [contentEndReason.REPLACED]: "Replaced by another flow",
  [contentEndReason.TOOLTIP_TARGET_MISSING]: "Tooltip target missing",
  [contentEndReason.CONTENT_NOT_FOUND]: "Content not found",
  [contentEndReason.SESSION_TIMEOUT]: "Session timeout",
  [contentEndReason.SYSTEM_CLOSED]: "System closed",
  [contentEndReason.URL_START_CLOSED]: "Dismissed due to URL start",
  [contentEndReason.USER_STARTED_OTHER_CONTENT]: "User started other content",
  [contentEndReason.PROGRAM_STARTED_OTHER_CONTENT]: "Program started other content",
  [contentEndReason.STEP_NOT_FOUND]: "Step not found",
  [contentEndReason.AUTO_DISMISSED]: "Auto dismissed",
  [contentEndReason.UNPUBLISHED_CONTENT]: "Unpublished content",
  [contentEndReason.END_FROM_PROGRAM]: "Ended from program",
  [contentEndReason.LAUNCHER_DEACTIVATED]: "Launcher deactivated",
  // End reasons (new - specific action types)
  [contentEndReason.CLOSE_BUTTON_DISMISS]: "Dismissed by close button",
  [contentEndReason.BACKDROP_DISMISS]: "Dismissed by backdrop click",
  [contentEndReason.DISMISS_BUTTON]: "Dismissed by dismiss button",
  [contentEndReason.TRIGGER_DISMISS]: "Dismissed by trigger condition",
  [contentEndReason.ACTION_DISMISS]: "Dismissed by action",
  [contentEndReason.STORE_NOT_FOUND]: "Store not found",
  [contentEndReason.ADMIN_ENDED]: "Ended by admin"
};
var MAX_WAIT_SECONDS = 300;

// src/constants/license.ts
var LICENSE_FEATURE_TWO_FACTOR = "two_factor_auth";

// src/constants/integration-catalog.ts
var INTEGRATION_CATALOG = [
  {
    provider: "amplitude",
    kind: "analytics",
    name: "Amplitude",
    imagePath: "/images/integrations/amplitude.png",
    hasRegion: true,
    hasInbound: true,
    hasObjectSync: false
  },
  {
    provider: "heap",
    kind: "analytics",
    name: "Heap",
    imagePath: "/images/integrations/heap.png",
    hasRegion: false,
    hasInbound: false,
    hasObjectSync: false
  },
  {
    provider: "mixpanel",
    kind: "analytics",
    name: "Mixpanel",
    imagePath: "/images/integrations/mixpanel.png",
    hasRegion: true,
    hasInbound: true,
    hasObjectSync: false
  },
  {
    provider: "posthog",
    kind: "analytics",
    name: "PostHog",
    imagePath: "/images/integrations/posthog.png",
    hasRegion: true,
    hasInbound: false,
    hasObjectSync: false
  },
  {
    provider: "segment",
    kind: "analytics",
    name: "Segment",
    imagePath: "/images/integrations/segment.png",
    hasRegion: true,
    hasInbound: false,
    hasObjectSync: false
  },
  {
    provider: "hubspot",
    kind: "crm",
    name: "HubSpot",
    imagePath: "/images/integrations/hubspot.png",
    hasRegion: false,
    hasInbound: false,
    hasObjectSync: true
  },
  {
    provider: "zapier",
    kind: "automation",
    name: "Zapier",
    imagePath: "/images/integrations/zapier.svg",
    externalUrl: "https://zapier.com/apps/usertour/integrations",
    hasRegion: false,
    hasInbound: false,
    hasObjectSync: false
  }
];
var catalogEntryForSource = (source) => source ? INTEGRATION_CATALOG.find((entry) => entry.provider === source) : void 0;
var SYNC_INTEGRATION_PROVIDERS = INTEGRATION_CATALOG.filter((entry) => entry.hasObjectSync).map((entry) => entry.provider);

// src/constants/permission.ts
import { Capability, Role } from "@usertour/types";
var READ = [
  Capability.ContentRead,
  Capability.ThemeRead,
  Capability.AttributeRead,
  Capability.EventRead,
  Capability.LocalizationRead,
  Capability.SegmentRead,
  Capability.UserRead,
  Capability.CompanyRead,
  Capability.SessionRead,
  Capability.AnalyticsRead,
  Capability.EnvironmentRead,
  Capability.ProjectRead,
  Capability.ProjectActivate
];
var WRITE = [
  Capability.ContentCreate,
  Capability.ContentUpdate,
  // Subject to the membership publish whitelist unless the role also holds
  // ContentPublishAnyEnvironment (ADMIN tier).
  Capability.ContentPublish,
  Capability.ContentDelete,
  Capability.ThemeCreate,
  Capability.ThemeUpdate,
  Capability.ThemeDelete,
  Capability.AttributeCreate,
  Capability.AttributeUpdate,
  Capability.AttributeDelete,
  Capability.EventCreate,
  Capability.EventUpdate,
  Capability.EventDelete,
  Capability.LocalizationCreate,
  Capability.LocalizationUpdate,
  Capability.LocalizationDelete,
  Capability.SegmentCreate,
  Capability.SegmentUpdate,
  Capability.SegmentDelete,
  Capability.UserWrite,
  Capability.UserDelete,
  Capability.CompanyWrite,
  Capability.CompanyDelete,
  Capability.SessionManage,
  Capability.EnvironmentManage,
  // Project-internal operations a builder needs to ship and verify content:
  // connect analytics/CRM integrations, wire webhooks, read the SDK token to
  // install, rotate signing secrets.
  Capability.IntegrationRead,
  Capability.IntegrationManage,
  Capability.WebhookRead,
  Capability.WebhookManage,
  Capability.AccessTokenRead,
  Capability.AccessTokenManage
];
var ADMIN = [
  Capability.ContentPublishAnyEnvironment,
  Capability.TeamRead,
  Capability.TeamManage,
  Capability.SsoRead,
  Capability.SsoManage,
  Capability.ProjectManage,
  Capability.AuditRead,
  // Read-only: an ADMIN can see the plan, usage and license status (and
  // therefore why content stopped delivering) without being able to spend.
  Capability.BillingRead
];
var OWNER_ONLY = [Capability.BillingManage, Capability.TeamTransferOwnership];
var ROLE_CAPABILITIES = {
  [Role.VIEWER]: [...READ],
  [Role.EDITOR]: [...READ, ...WRITE],
  [Role.ADMIN]: [...READ, ...WRITE, ...ADMIN],
  [Role.OWNER]: [...READ, ...WRITE, ...ADMIN, ...OWNER_ONLY]
};
var roleCan = (role, capability) => {
  var _a, _b;
  return (_b = (_a = ROLE_CAPABILITIES[role]) == null ? void 0 : _a.includes(capability)) != null ? _b : false;
};

// src/constants/theme-settings-constraints.ts
var THEME_SETTING_CONSTRAINTS = {
  "announcement.bubbleWidth": { kind: "number", min: 100, max: 1e3 },
  "announcement.modalWidth": { kind: "number", min: 100, max: 1e3 },
  "avatar.size": { kind: "number", min: 10, max: 200 },
  "backdrop.color": { kind: "color", allowAuto: false },
  "backdrop.highlight.color": { kind: "color", allowAuto: false },
  "backdrop.highlight.opacity": {
    kind: "number",
    min: 0,
    max: 100,
    describe: "Percent, 0-100 (not 0-1)."
  },
  "backdrop.highlight.radius": { kind: "number", min: 0, max: 100 },
  "backdrop.highlight.spread": { kind: "number", min: 0, max: 100 },
  "backdrop.highlight.type": { kind: "enum", values: ["outside", "inside"] },
  "backdrop.opacity": { kind: "number", min: 0, max: 100, describe: "Percent, 0-100 (not 0-1)." },
  "banner.animationDuration": {
    kind: "number",
    min: 0,
    max: 1e4,
    describe: "Milliseconds."
  },
  "banner.animationTiming": { kind: "enum", values: ["smooth", "snappy", "gentle", "linear"] },
  "banner.backgroundColor.background": { kind: "color", allowAuto: true },
  "banner.padding": { kind: "number", min: 0, max: 100 },
  "banner.textColor.color": { kind: "color", allowAuto: true },
  "border.borderColor": { kind: "color", allowAuto: true },
  "border.borderRadius": { kind: "number", min: 0 },
  "border.borderWidth": { kind: "number", min: 0, max: 50 },
  "border.borderWidthEnabled": { kind: "boolean" },
  "brandColor.active": { kind: "color", allowAuto: true },
  "brandColor.background": { kind: "color", allowAuto: false },
  "brandColor.color": { kind: "color", allowAuto: false },
  "brandColor.hover": { kind: "color", allowAuto: true },
  "bubble.placement.position": {
    kind: "enum",
    values: [
      "leftTop",
      "centerTop",
      "rightTop",
      "leftBottom",
      "centerBottom",
      "rightBottom",
      "center"
    ]
  },
  "bubble.placement.positionOffsetX": { kind: "number", min: -1e3, max: 1e3 },
  "bubble.placement.positionOffsetY": { kind: "number", min: -1e3, max: 1e3 },
  "bubble.width": { kind: "number", min: 100, max: 1e3 },
  "buttons.borderRadius": { kind: "number", min: 0, max: 100 },
  "buttons.height": { kind: "number", min: 1, max: 100 },
  "buttons.minWidth": { kind: "number", min: 0, max: 500 },
  "buttons.primary.backgroundColor.active": { kind: "color", allowAuto: true },
  "buttons.primary.backgroundColor.background": { kind: "color", allowAuto: true },
  "buttons.primary.backgroundColor.hover": { kind: "color", allowAuto: true },
  "buttons.primary.border.borderWidth": { kind: "number", min: 0, max: 20 },
  "buttons.primary.border.color.active": { kind: "color", allowAuto: true },
  "buttons.primary.border.color.color": { kind: "color", allowAuto: true },
  "buttons.primary.border.color.hover": { kind: "color", allowAuto: true },
  "buttons.primary.border.enabled": { kind: "boolean" },
  "buttons.primary.fontWeight": {
    kind: "enum",
    values: [100, 200, 300, 400, 500, 600, 700, 800, 900]
  },
  "buttons.primary.textColor.active": { kind: "color", allowAuto: true },
  "buttons.primary.textColor.color": { kind: "color", allowAuto: true },
  "buttons.primary.textColor.hover": { kind: "color", allowAuto: true },
  "buttons.px": { kind: "number", min: 0, max: 100 },
  "buttons.secondary.backgroundColor.active": { kind: "color", allowAuto: true },
  "buttons.secondary.backgroundColor.background": { kind: "color", allowAuto: true },
  "buttons.secondary.backgroundColor.hover": { kind: "color", allowAuto: true },
  "buttons.secondary.border.borderWidth": { kind: "number", min: 0, max: 20 },
  "buttons.secondary.border.color.active": { kind: "color", allowAuto: true },
  "buttons.secondary.border.color.color": { kind: "color", allowAuto: true },
  "buttons.secondary.border.color.hover": { kind: "color", allowAuto: true },
  "buttons.secondary.border.enabled": { kind: "boolean" },
  "buttons.secondary.fontWeight": {
    kind: "enum",
    values: [100, 200, 300, 400, 500, 600, 700, 800, 900]
  },
  "buttons.secondary.textColor.active": { kind: "color", allowAuto: true },
  "buttons.secondary.textColor.color": { kind: "color", allowAuto: true },
  "buttons.secondary.textColor.hover": { kind: "color", allowAuto: true },
  "checklist.checkmarkColor": { kind: "color", allowAuto: true },
  "checklist.completedTaskTextDecoration": { kind: "enum", values: ["none", "line-through"] },
  "checklist.placement.position": {
    kind: "enum",
    values: ["leftTop", "rightTop", "leftBottom", "rightBottom", "center"]
  },
  "checklist.placement.positionOffsetX": { kind: "number", min: 0, max: 1e3 },
  "checklist.placement.positionOffsetY": { kind: "number", min: 0, max: 1e3 },
  "checklist.width": { kind: "number", min: 100, max: 1e3 },
  "checklist.zIndex": { kind: "number" },
  "checklistLauncher.borderRadius": { kind: "number", min: 0, max: 100 },
  "checklistLauncher.color.active": { kind: "color", allowAuto: true },
  "checklistLauncher.color.background": { kind: "color", allowAuto: true },
  "checklistLauncher.color.color": { kind: "color", allowAuto: true },
  "checklistLauncher.color.hover": { kind: "color", allowAuto: true },
  "checklistLauncher.counter.background": { kind: "color", allowAuto: true },
  "checklistLauncher.counter.color": { kind: "color", allowAuto: true },
  "checklistLauncher.fontWeight": {
    kind: "enum",
    values: [100, 200, 300, 400, 500, 600, 700, 800, 900]
  },
  "checklistLauncher.height": { kind: "number", min: 10, max: 200 },
  "checklistLauncher.placement.position": {
    kind: "enum",
    values: ["leftTop", "rightTop", "leftBottom", "rightBottom", "center"]
  },
  "checklistLauncher.placement.positionOffsetX": { kind: "number", min: 0, max: 1e3 },
  "checklistLauncher.placement.positionOffsetY": { kind: "number", min: 0, max: 1e3 },
  customCss: { kind: "string" },
  "focusHighlight.color": { kind: "color", allowAuto: true },
  "focusHighlight.opacity": {
    kind: "number",
    min: 0,
    max: 100,
    describe: "Percent, 0-100 (not 0-1)."
  },
  "font.customFontFamily": {
    kind: "string",
    describe: 'Font family name used when font.fontFamily is "Custom font" (declare the face itself via customCss @font-face). When set this way it OVERRIDES font.fontFamily at render.'
  },
  "font.fontFamily": { kind: "string" },
  "font.fontSize": { kind: "number", min: 10, max: 50 },
  "font.fontWeightBold": { kind: "enum", values: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
  "font.fontWeightNormal": { kind: "enum", values: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
  "font.h1FontSize": { kind: "number", min: 10, max: 100 },
  "font.h2FontSize": { kind: "number", min: 10, max: 100 },
  "font.lineHeight": { kind: "number", min: 10, max: 50 },
  "font.linkColor": { kind: "color", allowAuto: true },
  "launcherBeacon.color": { kind: "color", allowAuto: true },
  "launcherBeacon.size": { kind: "number", min: 1, max: 100 },
  "launcherButtons.borderRadius": { kind: "number", min: 0, max: 100 },
  "launcherButtons.height": { kind: "number", min: 1, max: 200 },
  "launcherButtons.primary.backgroundColor.active": { kind: "color", allowAuto: true },
  "launcherButtons.primary.backgroundColor.background": { kind: "color", allowAuto: true },
  "launcherButtons.primary.backgroundColor.hover": { kind: "color", allowAuto: true },
  "launcherButtons.primary.border.borderWidth": { kind: "number", min: 0, max: 100 },
  "launcherButtons.primary.border.color.active": { kind: "color", allowAuto: true },
  "launcherButtons.primary.border.color.color": { kind: "color", allowAuto: true },
  "launcherButtons.primary.border.color.hover": { kind: "color", allowAuto: true },
  "launcherButtons.primary.border.enabled": { kind: "boolean" },
  "launcherButtons.primary.fontWeight": {
    kind: "enum",
    values: [100, 200, 300, 400, 500, 600, 700, 800, 900]
  },
  "launcherButtons.primary.textColor.active": { kind: "color", allowAuto: true },
  "launcherButtons.primary.textColor.color": { kind: "color", allowAuto: true },
  "launcherButtons.primary.textColor.hover": { kind: "color", allowAuto: true },
  "launcherButtons.px": { kind: "number", min: 0, max: 100 },
  "launcherButtons.width": { kind: "number", min: 1, max: 200 },
  "launcherIcon.color.active": { kind: "color", allowAuto: true },
  "launcherIcon.color.color": { kind: "color", allowAuto: true },
  "launcherIcon.color.hover": { kind: "color", allowAuto: true },
  "launcherIcon.opacity": {
    kind: "number",
    min: 0,
    max: 100,
    describe: "Percent, 0-100 (not 0-1)."
  },
  "launcherIcon.size": { kind: "number", min: 1, max: 200 },
  "mainColor.active": { kind: "color", allowAuto: true },
  "mainColor.background": { kind: "color", allowAuto: false },
  "mainColor.color": { kind: "color", allowAuto: false },
  "mainColor.hover": { kind: "color", allowAuto: true },
  "modal.backdropClickBehavior": { kind: "enum", values: ["do-nothing", "dismiss-flow"] },
  "modal.padding": { kind: "number", min: 0, max: 100 },
  "modal.width": { kind: "number", min: 100, max: 1e3 },
  "progress.chainRoundedHeight": {
    kind: "number",
    min: 1,
    max: 10,
    describe: 'Pixels. Applies ONLY when progress.type is "chain-rounded".'
  },
  "progress.chainSquaredHeight": {
    kind: "number",
    min: 1,
    max: 10,
    describe: 'Pixels. Applies ONLY when progress.type is "chain-squared".'
  },
  "progress.color": { kind: "color", allowAuto: true },
  "progress.dotsHeight": {
    kind: "number",
    min: 1,
    max: 10,
    describe: 'Pixels. Applies ONLY when progress.type is "dots".'
  },
  "progress.enabled": { kind: "boolean" },
  "progress.height": {
    kind: "number",
    min: 0,
    max: 10,
    describe: 'Pixels. Applies ONLY when progress.type is "full-width" \u2014 each progress type reads its own height key.'
  },
  "progress.narrowHeight": {
    kind: "number",
    min: 1,
    max: 10,
    describe: 'Pixels. Applies ONLY when progress.type is "narrow".'
  },
  "progress.numberedHeight": {
    kind: "number",
    min: 1,
    max: 100,
    describe: 'Pixels. Applies ONLY when progress.type is "numbered".'
  },
  "progress.position": { kind: "enum", values: ["top", "bottom"] },
  "progress.type": {
    kind: "enum",
    values: ["full-width", "narrow", "chain-rounded", "chain-squared", "dots", "numbered"]
  },
  "resourceCenter.headerBackground.color": { kind: "color", allowAuto: true },
  "resourceCenter.headerBackground.gradientFrom": { kind: "color", allowAuto: true },
  "resourceCenter.headerBackground.gradientTo": { kind: "color", allowAuto: true },
  "resourceCenter.headerBackground.type": {
    kind: "enum",
    values: ["none", "color", "gradient", "image"]
  },
  "resourceCenter.largeWidth": { kind: "number", min: 100, max: 2e3 },
  "resourceCenter.maxHeight": { kind: "number", min: 100, max: 2e3 },
  "resourceCenter.normalWidth": { kind: "number", min: 100, max: 1e3 },
  "resourceCenter.offsetX": { kind: "number", min: 0, max: 1e3 },
  "resourceCenter.offsetY": { kind: "number", min: 0, max: 1e3 },
  "resourceCenter.placement": {
    kind: "enum",
    values: ["top-left", "top-right", "bottom-left", "bottom-right"]
  },
  "resourceCenter.transitionDuration": {
    kind: "number",
    min: 0,
    max: 1e4,
    describe: "Milliseconds."
  },
  "resourceCenter.zIndex": { kind: "number" },
  "resourceCenterLauncherButton.borderRadius": { kind: "number", min: 0, max: 100 },
  "resourceCenterUnreadBadge.backgroundColor": { kind: "color", allowAuto: false },
  "resourceCenterUnreadBadge.textColor": { kind: "color", allowAuto: false },
  "resourceCenterLauncherButton.color.active": { kind: "color", allowAuto: true },
  "resourceCenterLauncherButton.color.background": { kind: "color", allowAuto: true },
  "resourceCenterLauncherButton.color.foreground": { kind: "color", allowAuto: true },
  "resourceCenterLauncherButton.color.hover": { kind: "color", allowAuto: true },
  "resourceCenterLauncherButton.height": { kind: "number", min: 10, max: 200 },
  "resourceCenterLauncherButton.iconType": {
    kind: "enum",
    values: ["default-question-mark", "plaintext-question-mark", "custom"]
  },
  "resourceCenterLauncherButton.imageHeight": { kind: "number", min: 10, max: 200 },
  "resourceCenterLauncherButton.textMode": {
    kind: "enum",
    values: ["resource-center-text", "no-text"]
  },
  "survey.color": { kind: "color", allowAuto: true },
  "tooltip.missingTargetBehavior": { kind: "enum", values: ["auto-dismiss", "use-bubble"] },
  "tooltip.missingTargetTolerance": {
    kind: "number",
    min: 0,
    max: 10,
    describe: "SECONDS to keep looking for a missing tooltip target before missingTargetBehavior kicks in. A runtime SDK missing-target setting, when configured, takes precedence over this."
  },
  "tooltip.notchSize": { kind: "number", min: 5, max: 100 },
  "tooltip.width": { kind: "number", min: 100, max: 1e3 },
  "xbutton.color": { kind: "color", allowAuto: true }
};

// src/constants/announcement.ts
import {
  AnnouncementDistribution,
  AnnouncementPopupStyle,
  ContentEditorElementType
} from "@usertour/types";
var DEFAULT_EDITOR_CONTENT = [
  {
    element: { type: ContentEditorElementType.GROUP },
    children: [
      {
        element: {
          type: ContentEditorElementType.COLUMN,
          style: {},
          width: { type: "fill" },
          justifyContent: "justify-start"
        },
        children: [
          {
            element: {
              data: [{ type: "paragraph", children: [{ text: "" }] }],
              type: ContentEditorElementType.TEXT
            },
            children: null
          }
        ]
      }
    ]
  }
];
var DEFAULT_ANNOUNCEMENT_DATA = {
  title: "",
  introContent: DEFAULT_EDITOR_CONTENT,
  enableReadMore: false,
  readMoreLabel: "Read more",
  detailContent: DEFAULT_EDITOR_CONTENT,
  distribution: AnnouncementDistribution.BADGE
};
var DEFAULT_POPUP_CONFIG = {
  style: AnnouncementPopupStyle.BUBBLE
};
var ANNOUNCEMENT_SEEN_SOURCES = [
  "resource_center",
  "modal",
  "bubble"
];
var ANNOUNCEMENT_FEED_SCAN_LIMIT = 50;

// src/constants/project-defaults.ts
import {
  AttributeBizTypes,
  AttributeDataType,
  BizEvents,
  CompanyAttributes,
  EventAttributes,
  UserAttributes
} from "@usertour/types";
var defaultEvents = [
  {
    displayName: "Page Viewed",
    codeName: BizEvents.PAGE_VIEWED,
    description: "When a page is viewed in your app",
    attributes: [
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Flow Started",
    codeName: BizEvents.FLOW_STARTED,
    description: "When a flow session starts",
    attributes: [
      EventAttributes.FLOW_ID,
      EventAttributes.FLOW_NAME,
      EventAttributes.FLOW_SESSION_ID,
      EventAttributes.FLOW_START_REASON,
      EventAttributes.FLOW_VERSION_ID,
      EventAttributes.FLOW_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Flow Dismissed/Ended",
    codeName: BizEvents.FLOW_ENDED,
    description: "When a flow is dismissed",
    attributes: [
      EventAttributes.FLOW_END_REASON,
      EventAttributes.FLOW_ID,
      EventAttributes.FLOW_NAME,
      EventAttributes.FLOW_SESSION_ID,
      EventAttributes.FLOW_STEP_CVID,
      EventAttributes.FLOW_STEP_ID,
      EventAttributes.FLOW_STEP_NAME,
      EventAttributes.FLOW_STEP_NUMBER,
      EventAttributes.FLOW_STEP_PROGRESS,
      EventAttributes.FLOW_VERSION_ID,
      EventAttributes.FLOW_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Flow Step Seen",
    codeName: BizEvents.FLOW_STEP_SEEN,
    description: "When a flow step becomes visible",
    attributes: [
      EventAttributes.FLOW_ID,
      EventAttributes.FLOW_NAME,
      EventAttributes.FLOW_SESSION_ID,
      EventAttributes.FLOW_STEP_CVID,
      EventAttributes.FLOW_STEP_ID,
      EventAttributes.FLOW_STEP_NAME,
      EventAttributes.FLOW_STEP_NUMBER,
      EventAttributes.FLOW_STEP_PROGRESS,
      EventAttributes.FLOW_VERSION_ID,
      EventAttributes.FLOW_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Flow Step Completed",
    codeName: BizEvents.FLOW_STEP_COMPLETED,
    description: "When a flow step's completion conditions are met",
    attributes: [
      EventAttributes.FLOW_ID,
      EventAttributes.FLOW_NAME,
      EventAttributes.FLOW_SESSION_ID,
      EventAttributes.FLOW_STEP_CVID,
      EventAttributes.FLOW_STEP_ID,
      EventAttributes.FLOW_STEP_NAME,
      EventAttributes.FLOW_STEP_NUMBER,
      EventAttributes.FLOW_STEP_PROGRESS,
      EventAttributes.FLOW_VERSION_ID,
      EventAttributes.FLOW_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Flow Completed",
    codeName: BizEvents.FLOW_COMPLETED,
    description: "When a flow reaches a goal step",
    attributes: [
      EventAttributes.FLOW_ID,
      EventAttributes.FLOW_NAME,
      EventAttributes.FLOW_SESSION_ID,
      EventAttributes.FLOW_STEP_CVID,
      EventAttributes.FLOW_STEP_ID,
      EventAttributes.FLOW_STEP_NAME,
      EventAttributes.FLOW_STEP_NUMBER,
      EventAttributes.FLOW_STEP_PROGRESS,
      EventAttributes.FLOW_VERSION_ID,
      EventAttributes.FLOW_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Tooltip Target Missing",
    codeName: BizEvents.TOOLTIP_TARGET_MISSING,
    description: "When a tooltip step cannot find its anchor element on the page",
    attributes: [
      EventAttributes.FLOW_ID,
      EventAttributes.FLOW_NAME,
      EventAttributes.FLOW_SESSION_ID,
      EventAttributes.FLOW_STEP_CVID,
      EventAttributes.FLOW_STEP_ID,
      EventAttributes.FLOW_STEP_NAME,
      EventAttributes.FLOW_STEP_NUMBER,
      EventAttributes.FLOW_STEP_PROGRESS,
      EventAttributes.FLOW_VERSION_ID,
      EventAttributes.FLOW_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Launcher Activated",
    codeName: BizEvents.LAUNCHER_ACTIVATED,
    description: "When a launcher is activated by click or hover",
    attributes: [
      EventAttributes.LAUNCHER_ID,
      EventAttributes.LAUNCHER_NAME,
      EventAttributes.LAUNCHER_SESSION_ID,
      EventAttributes.LAUNCHER_VERSION_ID,
      EventAttributes.LAUNCHER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Launcher Dismissed",
    codeName: BizEvents.LAUNCHER_DISMISSED,
    description: "When a launcher is dismissed",
    attributes: [
      EventAttributes.LAUNCHER_ID,
      EventAttributes.LAUNCHER_NAME,
      EventAttributes.LAUNCHER_SESSION_ID,
      EventAttributes.LAUNCHER_END_REASON,
      EventAttributes.LAUNCHER_VERSION_ID,
      EventAttributes.LAUNCHER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Launcher Seen",
    codeName: BizEvents.LAUNCHER_SEEN,
    description: "When a launcher becomes visible",
    attributes: [
      EventAttributes.LAUNCHER_ID,
      EventAttributes.LAUNCHER_NAME,
      EventAttributes.LAUNCHER_SESSION_ID,
      EventAttributes.LAUNCHER_START_REASON,
      EventAttributes.LAUNCHER_VERSION_ID,
      EventAttributes.LAUNCHER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Banner Seen",
    codeName: BizEvents.BANNER_SEEN,
    description: "When a banner becomes visible",
    attributes: [
      EventAttributes.BANNER_ID,
      EventAttributes.BANNER_NAME,
      EventAttributes.BANNER_SESSION_ID,
      EventAttributes.BANNER_VERSION_ID,
      EventAttributes.BANNER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Banner Dismissed",
    codeName: BizEvents.BANNER_DISMISSED,
    description: "When a banner is dismissed",
    attributes: [
      EventAttributes.BANNER_END_REASON,
      EventAttributes.BANNER_ID,
      EventAttributes.BANNER_NAME,
      EventAttributes.BANNER_SESSION_ID,
      EventAttributes.BANNER_VERSION_ID,
      EventAttributes.BANNER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Resource Center Started",
    codeName: BizEvents.RESOURCE_CENTER_STARTED,
    description: "When a Resource Center session starts",
    attributes: [
      EventAttributes.RESOURCE_CENTER_ID,
      EventAttributes.RESOURCE_CENTER_NAME,
      EventAttributes.RESOURCE_CENTER_SESSION_ID,
      EventAttributes.RESOURCE_CENTER_START_REASON,
      EventAttributes.RESOURCE_CENTER_VERSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Resource Center Opened",
    codeName: BizEvents.RESOURCE_CENTER_OPENED,
    description: "When the Resource Center panel is opened",
    attributes: [
      EventAttributes.RESOURCE_CENTER_ID,
      EventAttributes.RESOURCE_CENTER_NAME,
      EventAttributes.RESOURCE_CENTER_SESSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Resource Center Closed",
    codeName: BizEvents.RESOURCE_CENTER_CLOSED,
    description: "When the Resource Center panel is closed",
    attributes: [
      EventAttributes.RESOURCE_CENTER_ID,
      EventAttributes.RESOURCE_CENTER_NAME,
      EventAttributes.RESOURCE_CENTER_SESSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Resource Center Clicked",
    codeName: BizEvents.RESOURCE_CENTER_CLICKED,
    description: "When a block inside the Resource Center is clicked",
    attributes: [
      EventAttributes.RESOURCE_CENTER_ID,
      EventAttributes.RESOURCE_CENTER_NAME,
      EventAttributes.RESOURCE_CENTER_SESSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_NUMBER,
      EventAttributes.RESOURCE_CENTER_TAB_ID,
      EventAttributes.RESOURCE_CENTER_TAB_NAME,
      EventAttributes.RESOURCE_CENTER_BLOCK_ID,
      EventAttributes.RESOURCE_CENTER_BLOCK_NAME,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Resource Center Dismissed",
    codeName: BizEvents.RESOURCE_CENTER_DISMISSED,
    description: "When the Resource Center session is dismissed",
    attributes: [
      EventAttributes.RESOURCE_CENTER_END_REASON,
      EventAttributes.RESOURCE_CENTER_ID,
      EventAttributes.RESOURCE_CENTER_NAME,
      EventAttributes.RESOURCE_CENTER_SESSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_ID,
      EventAttributes.RESOURCE_CENTER_VERSION_NUMBER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Question Answered",
    codeName: BizEvents.QUESTION_ANSWERED,
    description: "When a survey question is answered",
    attributes: [
      EventAttributes.FLOW_ID,
      EventAttributes.FLOW_NAME,
      EventAttributes.FLOW_VERSION_ID,
      EventAttributes.FLOW_VERSION_NUMBER,
      EventAttributes.LIST_ANSWER,
      EventAttributes.NUMBER_ANSWER,
      EventAttributes.QUESTION_CVID,
      EventAttributes.QUESTION_NAME,
      EventAttributes.QUESTION_TYPE,
      EventAttributes.TEXT_ANSWER,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Checklist Completed",
    codeName: BizEvents.CHECKLIST_COMPLETED,
    description: "When all checklist tasks are complete",
    attributes: [
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH,
      EventAttributes.CHECKLIST_ID,
      EventAttributes.CHECKLIST_NAME,
      EventAttributes.CHECKLIST_SESSION_ID,
      EventAttributes.CHECKLIST_VERSION_ID,
      EventAttributes.CHECKLIST_VERSION_NUMBER
    ]
  },
  {
    displayName: "Checklist Dismissed/Ended",
    codeName: BizEvents.CHECKLIST_DISMISSED,
    description: "When a checklist is dismissed",
    attributes: [
      EventAttributes.CHECKLIST_END_REASON,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH,
      EventAttributes.CHECKLIST_VERSION_NUMBER,
      EventAttributes.CHECKLIST_ID,
      EventAttributes.CHECKLIST_NAME,
      EventAttributes.CHECKLIST_SESSION_ID,
      EventAttributes.CHECKLIST_VERSION_ID
    ]
  },
  {
    displayName: "Checklist Hidden",
    codeName: BizEvents.CHECKLIST_HIDDEN,
    description: "When the checklist panel is collapsed to its launcher",
    attributes: [
      EventAttributes.CHECKLIST_VERSION_NUMBER,
      EventAttributes.CHECKLIST_NAME,
      EventAttributes.CHECKLIST_ID,
      EventAttributes.CHECKLIST_SESSION_ID,
      EventAttributes.CHECKLIST_VERSION_ID,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH,
      EventAttributes.PAGE_URL,
      EventAttributes.LOCALE_CODE
    ]
  },
  {
    displayName: "Checklist Shown",
    codeName: BizEvents.CHECKLIST_SEEN,
    description: "When the checklist panel is expanded",
    attributes: [
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.LOCALE_CODE,
      EventAttributes.CHECKLIST_ID,
      EventAttributes.CHECKLIST_VERSION_NUMBER,
      EventAttributes.CHECKLIST_SESSION_ID,
      EventAttributes.CHECKLIST_VERSION_ID,
      EventAttributes.CHECKLIST_NAME,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Checklist Started",
    codeName: BizEvents.CHECKLIST_STARTED,
    description: "When a checklist session starts",
    attributes: [
      EventAttributes.VIEWPORT_WIDTH,
      EventAttributes.LOCALE_CODE,
      EventAttributes.CHECKLIST_VERSION_NUMBER,
      EventAttributes.CHECKLIST_VERSION_ID,
      EventAttributes.CHECKLIST_START_REASON,
      EventAttributes.CHECKLIST_SESSION_ID,
      EventAttributes.CHECKLIST_NAME,
      EventAttributes.CHECKLIST_ID,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.PAGE_URL
    ]
  },
  {
    displayName: "Checklist Task Clicked",
    codeName: BizEvents.CHECKLIST_TASK_CLICKED,
    description: "When a checklist task is clicked",
    attributes: [
      EventAttributes.CHECKLIST_SESSION_ID,
      EventAttributes.CHECKLIST_NAME,
      EventAttributes.CHECKLIST_TASK_ID,
      EventAttributes.CHECKLIST_TASK_CVID,
      EventAttributes.CHECKLIST_ID,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH,
      EventAttributes.PAGE_URL,
      EventAttributes.LOCALE_CODE,
      EventAttributes.CHECKLIST_VERSION_NUMBER,
      EventAttributes.CHECKLIST_VERSION_ID,
      EventAttributes.CHECKLIST_TASK_NAME
    ]
  },
  {
    displayName: "Announcement Seen",
    codeName: BizEvents.ANNOUNCEMENT_SEEN,
    attributes: [
      EventAttributes.ANNOUNCEMENT_ID,
      EventAttributes.ANNOUNCEMENT_NAME,
      EventAttributes.ANNOUNCEMENT_VERSION_ID,
      EventAttributes.ANNOUNCEMENT_VERSION_NUMBER,
      EventAttributes.ANNOUNCEMENT_LEVEL,
      EventAttributes.ANNOUNCEMENT_SOURCE,
      EventAttributes.LOCALE_CODE,
      EventAttributes.PAGE_URL,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH
    ]
  },
  {
    displayName: "Checklist Task Completed",
    codeName: BizEvents.CHECKLIST_TASK_COMPLETED,
    description: "When a checklist task's completion conditions are met",
    attributes: [
      EventAttributes.PAGE_URL,
      EventAttributes.CHECKLIST_VERSION_NUMBER,
      EventAttributes.CHECKLIST_VERSION_ID,
      EventAttributes.CHECKLIST_TASK_NAME,
      EventAttributes.CHECKLIST_TASK_ID,
      EventAttributes.CHECKLIST_TASK_CVID,
      EventAttributes.CHECKLIST_ID,
      EventAttributes.CHECKLIST_SESSION_ID,
      EventAttributes.CHECKLIST_NAME,
      EventAttributes.VIEWPORT_HEIGHT,
      EventAttributes.VIEWPORT_WIDTH,
      EventAttributes.LOCALE_CODE
    ]
  }
];
var defaultAttributes = [
  {
    codeName: UserAttributes.EMAIL,
    displayName: "Email",
    bizType: AttributeBizTypes.User,
    dataType: AttributeDataType.String,
    description: "Email address belonging to the user"
  },
  {
    codeName: UserAttributes.NAME,
    displayName: "Name",
    bizType: AttributeBizTypes.User,
    dataType: AttributeDataType.String,
    description: "Full name of the user"
  },
  {
    codeName: UserAttributes.FIRST_SEEN_AT,
    displayName: "First Seen",
    bizType: AttributeBizTypes.User,
    dataType: AttributeDataType.DateTime,
    description: "When the user first interacted with Usertour"
  },
  {
    codeName: UserAttributes.LAST_SEEN_AT,
    displayName: "Last Seen",
    bizType: AttributeBizTypes.User,
    dataType: AttributeDataType.DateTime,
    description: "When the user most recently interacted with Usertour"
  },
  {
    codeName: UserAttributes.SIGNED_UP_AT,
    displayName: "Signed Up",
    bizType: AttributeBizTypes.User,
    dataType: AttributeDataType.DateTime,
    description: "When the user first signed up to your app"
  },
  {
    codeName: UserAttributes.LOCALE_CODE,
    displayName: "Locale Code",
    bizType: AttributeBizTypes.User,
    dataType: AttributeDataType.String,
    description: "The user's locale, used to pick which localized content to deliver"
  },
  {
    codeName: CompanyAttributes.NAME,
    displayName: "Company Name",
    bizType: AttributeBizTypes.Company,
    dataType: AttributeDataType.String,
    description: "Name of the company"
  },
  {
    codeName: CompanyAttributes.FIRST_SEEN_AT,
    displayName: "Company First Seen",
    bizType: AttributeBizTypes.Company,
    dataType: AttributeDataType.DateTime,
    description: "When any member of the company first appeared in Usertour"
  },
  {
    codeName: CompanyAttributes.LAST_SEEN_AT,
    displayName: "Company Last Seen",
    bizType: AttributeBizTypes.Company,
    dataType: AttributeDataType.DateTime,
    description: "When any member of the company most recently appeared in Usertour"
  },
  {
    codeName: CompanyAttributes.SIGNED_UP_AT,
    displayName: "Company Signed Up",
    bizType: AttributeBizTypes.Company,
    dataType: AttributeDataType.DateTime,
    description: "When the company first signed up to your app"
  },
  {
    codeName: EventAttributes.FLOW_ID,
    displayName: "Flow ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour flow"
  },
  {
    codeName: EventAttributes.FLOW_NAME,
    displayName: "Flow Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour flow"
  },
  {
    codeName: EventAttributes.FLOW_SESSION_ID,
    displayName: "Flow Session ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "A user's session viewing this flow"
  },
  {
    codeName: EventAttributes.FLOW_START_REASON,
    displayName: "Flow Start Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the flow started"
  },
  {
    codeName: EventAttributes.FLOW_END_REASON,
    displayName: "Flow End Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the flow ended"
  },
  {
    codeName: EventAttributes.FLOW_STEP_ID,
    displayName: "Flow Step ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour flow step"
  },
  {
    codeName: EventAttributes.FLOW_STEP_CVID,
    displayName: "Flow Step CVID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Cross-version identifier of the Usertour flow step"
  },
  {
    codeName: EventAttributes.FLOW_STEP_NAME,
    displayName: "Flow Step Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour flow step"
  },
  {
    codeName: EventAttributes.FLOW_STEP_NUMBER,
    displayName: "Flow Step Number",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Position of the Usertour flow step"
  },
  {
    codeName: EventAttributes.FLOW_STEP_PROGRESS,
    displayName: "Flow Step Progress",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Progress percentage of the Usertour flow step toward its goal"
  },
  {
    codeName: EventAttributes.FLOW_VERSION_ID,
    displayName: "Flow Version ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour flow version"
  },
  {
    codeName: EventAttributes.FLOW_VERSION_NUMBER,
    displayName: "Flow Version Number",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Number of the Usertour flow version"
  },
  {
    codeName: EventAttributes.LAUNCHER_ID,
    displayName: "Launcher ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour launcher"
  },
  {
    codeName: EventAttributes.LAUNCHER_NAME,
    displayName: "Launcher Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour launcher"
  },
  {
    codeName: EventAttributes.LAUNCHER_SESSION_ID,
    displayName: "Launcher Session ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "A user's session viewing this launcher"
  },
  {
    codeName: EventAttributes.LAUNCHER_VERSION_ID,
    displayName: "Launcher Version ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour launcher version"
  },
  {
    codeName: EventAttributes.LAUNCHER_VERSION_NUMBER,
    displayName: "Launcher Version Number",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Number of the Usertour launcher version"
  },
  {
    // Referenced by LAUNCHER_SEEN's attribute list and written by the SEEN event
    // builder, but the DEFINITION was missing here — so the Attribute row was
    // never seeded, the AttributeOnEvent link never made, and the reason was
    // silently dropped from every launcher seen event (launcher recon L1, the
    // same class as the RC/announcement reason gaps).
    codeName: EventAttributes.LAUNCHER_START_REASON,
    displayName: "Launcher Start Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the launcher started"
  },
  {
    codeName: EventAttributes.LAUNCHER_END_REASON,
    displayName: "Launcher End Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the launcher ended"
  },
  {
    codeName: EventAttributes.BANNER_ID,
    displayName: "Banner ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour banner"
  },
  {
    codeName: EventAttributes.BANNER_NAME,
    displayName: "Banner Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour banner"
  },
  {
    codeName: EventAttributes.BANNER_SESSION_ID,
    displayName: "Banner Session ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "A user's session viewing this banner"
  },
  {
    codeName: EventAttributes.BANNER_VERSION_ID,
    displayName: "Banner Version ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour banner version"
  },
  {
    codeName: EventAttributes.BANNER_VERSION_NUMBER,
    displayName: "Banner Version Number",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Number of the Usertour banner version"
  },
  {
    codeName: EventAttributes.BANNER_END_REASON,
    displayName: "Banner End Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the banner ended"
  },
  {
    codeName: EventAttributes.CHECKLIST_ID,
    displayName: "Checklist ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour checklist"
  },
  {
    codeName: EventAttributes.CHECKLIST_NAME,
    displayName: "Checklist Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour checklist"
  },
  {
    codeName: EventAttributes.CHECKLIST_SESSION_ID,
    displayName: "Checklist Session ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "A user's session viewing this checklist"
  },
  {
    codeName: EventAttributes.CHECKLIST_VERSION_ID,
    displayName: "Checklist Version ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour checklist version"
  },
  {
    codeName: EventAttributes.CHECKLIST_VERSION_NUMBER,
    displayName: "Checklist Version Number",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Number of the Usertour checklist version"
  },
  {
    codeName: EventAttributes.CHECKLIST_END_REASON,
    displayName: "Checklist End Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the checklist ended"
  },
  {
    codeName: EventAttributes.CHECKLIST_START_REASON,
    displayName: "Checklist Start Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the checklist started"
  },
  {
    codeName: EventAttributes.CHECKLIST_TASK_CVID,
    displayName: "Checklist Task CVID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Stable identifier of the Usertour checklist task that doesn't change across versions"
  },
  {
    codeName: EventAttributes.CHECKLIST_TASK_ID,
    displayName: "Checklist Task ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour checklist task"
  },
  {
    codeName: EventAttributes.CHECKLIST_TASK_NAME,
    displayName: "Checklist Task Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour checklist task"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_ID,
    displayName: "Resource Center ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour resource center"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_NAME,
    displayName: "Resource Center Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour resource center"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_SESSION_ID,
    displayName: "Resource Center Session ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "A user's session viewing this resource center"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_VERSION_ID,
    displayName: "Resource Center Version ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour resource center version"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_VERSION_NUMBER,
    displayName: "Resource Center Version Number",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Number of the Usertour resource center version"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_BLOCK_ID,
    displayName: "Resource Center Block ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour resource center block"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_BLOCK_NAME,
    displayName: "Resource Center Block Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour resource center block"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_TAB_ID,
    displayName: "Resource Center Tab ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour resource center tab the block belongs to"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_TAB_NAME,
    displayName: "Resource Center Tab Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour resource center tab the block belongs to"
  },
  {
    // Referenced by the RESOURCE_CENTER_STARTED event's attribute list since
    // that event shipped, but the attribute DEFINITION was missing here — so
    // the Attribute row was never seeded, the AttributeOnEvent link never
    // created, and filterEventDataByAttributes silently dropped the reason
    // from every started event (RC tier-C finding). The diff-based
    // initialization backfills existing projects once this exists.
    codeName: EventAttributes.RESOURCE_CENTER_START_REASON,
    displayName: "Resource Center Start Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the resource center started"
  },
  {
    codeName: EventAttributes.RESOURCE_CENTER_END_REASON,
    displayName: "Resource Center End Reason",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Why the resource center ended"
  },
  {
    codeName: EventAttributes.EVENT_TRACKER_ID,
    displayName: "Event Tracker ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour event tracker"
  },
  {
    codeName: EventAttributes.EVENT_TRACKER_NAME,
    displayName: "Event Tracker Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour event tracker"
  },
  {
    codeName: EventAttributes.EVENT_TRACKER_VERSION_ID,
    displayName: "Event Tracker Version ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour event tracker version"
  },
  {
    codeName: EventAttributes.EVENT_TRACKER_VERSION_NUMBER,
    displayName: "Event Tracker Version Number",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Number of the Usertour event tracker version"
  },
  {
    codeName: EventAttributes.ANNOUNCEMENT_ID,
    displayName: "Announcement ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour announcement"
  },
  {
    codeName: EventAttributes.ANNOUNCEMENT_NAME,
    displayName: "Announcement Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the Usertour announcement"
  },
  {
    codeName: EventAttributes.ANNOUNCEMENT_VERSION_ID,
    displayName: "Announcement Version ID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Unique identifier of the Usertour announcement version"
  },
  {
    codeName: EventAttributes.ANNOUNCEMENT_VERSION_NUMBER,
    displayName: "Announcement Version Number",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Number of the Usertour announcement version"
  },
  {
    codeName: EventAttributes.ANNOUNCEMENT_LEVEL,
    displayName: "Announcement Level",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "How the announcement was delivered (silent, badge, popup)"
  },
  {
    codeName: EventAttributes.ANNOUNCEMENT_SOURCE,
    displayName: "Announcement Source",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Where the announcement was shown (e.g. resource_center)"
  },
  {
    codeName: EventAttributes.LIST_ANSWER,
    displayName: "List Answer",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.List,
    description: "Option(s) chosen from the available list"
  },
  {
    codeName: EventAttributes.NUMBER_ANSWER,
    displayName: "Number Answer",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Numeric value submitted as the answer"
  },
  {
    codeName: EventAttributes.TEXT_ANSWER,
    displayName: "Text Answer",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Text value submitted as the answer"
  },
  {
    codeName: EventAttributes.LOCALE_CODE,
    displayName: "Locale Code",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Language/locale code associated with the content"
  },
  {
    codeName: EventAttributes.PAGE_URL,
    displayName: "Page URL",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "URL of the page on which the event was triggered"
  },
  {
    codeName: EventAttributes.VIEWPORT_HEIGHT,
    displayName: "Viewport Height",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Browser viewport height measured in pixels"
  },
  {
    codeName: EventAttributes.VIEWPORT_WIDTH,
    displayName: "Viewport Width",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.Number,
    description: "Browser viewport width measured in pixels"
  },
  {
    codeName: EventAttributes.QUESTION_CVID,
    displayName: "Question CVID",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Stable identifier of the question that doesn't change across versions"
  },
  {
    codeName: EventAttributes.QUESTION_NAME,
    displayName: "Question Name",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Display name of the question"
  },
  {
    codeName: EventAttributes.QUESTION_TYPE,
    displayName: "Question Type",
    bizType: AttributeBizTypes.Event,
    dataType: AttributeDataType.String,
    description: "Type/category of the question"
  }
];

// src/constants/theme-settings.ts
import {
  AvatarType,
  MissingTooltipTargetBehavior,
  ModalBackdropClickBehavior,
  ProgressBarPosition,
  ProgressBarType
} from "@usertour/types";
var defaultSettings = {
  font: {
    fontSize: 16,
    linkColor: "Auto",
    fontFamily: "System font",
    h1FontSize: 24,
    h2FontSize: 20,
    lineHeight: 24,
    fontWeightBold: 600,
    fontWeightNormal: 400
  },
  modal: {
    width: 600,
    padding: 40,
    backdropClickBehavior: ModalBackdropClickBehavior.DO_NOTHING
  },
  border: {
    borderColor: "Auto",
    borderWidth: 1,
    borderRadius: 10,
    borderWidthEnabled: false
  },
  survey: {
    color: "Auto"
  },
  buttons: {
    px: 16,
    height: 32,
    primary: {
      border: {
        color: {
          color: "Auto",
          hover: "Auto",
          active: "Auto",
          background: "#FFFFFF"
        },
        enabled: false,
        borderWidth: 1
      },
      textColor: {
        color: "Auto",
        hover: "Auto",
        active: "Auto",
        background: "#FFFFFF"
      },
      fontWeight: 600,
      backgroundColor: {
        color: "#FFFFFF",
        hover: "Auto",
        active: "Auto",
        background: "Auto"
      }
    },
    minWidth: 0,
    secondary: {
      border: {
        color: {
          color: "Auto",
          hover: "Auto",
          active: "Auto",
          background: "#FFFFFF"
        },
        enabled: true,
        borderWidth: 1
      },
      textColor: {
        color: "Auto",
        hover: "Auto",
        active: "Auto",
        background: "#FFFFFF"
      },
      fontWeight: 600,
      backgroundColor: {
        color: "#FFFFFF",
        hover: "Auto",
        active: "Auto",
        background: "Auto"
      }
    },
    borderRadius: 8
  },
  tooltip: {
    width: 300,
    notchSize: 20,
    missingTargetTolerance: 3,
    missingTargetBehavior: MissingTooltipTargetBehavior.AUTO_DISMISS
  },
  xbutton: {
    color: "Auto"
  },
  backdrop: {
    color: "#000000",
    opacity: 40,
    highlight: {
      type: "outside",
      color: "#ffffff",
      radius: 4,
      spread: 0,
      opacity: 50
    }
  },
  focusHighlight: {
    color: "Auto",
    opacity: 100
  },
  progress: {
    type: ProgressBarType.FULL_WIDTH,
    color: "Auto",
    height: 2,
    enabled: true,
    position: ProgressBarPosition.TOP,
    dotsHeight: 6,
    narrowHeight: 5,
    numberedHeight: 12,
    chainRoundedHeight: 6,
    chainSquaredHeight: 4
  },
  checklist: {
    width: 360,
    placement: {
      position: "rightBottom",
      positionOffsetX: 20,
      positionOffsetY: 20
    },
    checkmarkColor: "#4ade80",
    completedTaskTextDecoration: "line-through"
  },
  banner: {
    backgroundColor: {
      background: "Auto",
      color: "#FFFFFF",
      hover: "Auto",
      active: "Auto"
    },
    textColor: {
      background: "#FFFFFF",
      color: "Auto",
      hover: "Auto",
      active: "Auto"
    },
    padding: 8,
    animationDuration: 320,
    animationTiming: "smooth"
  },
  mainColor: {
    color: "#0f172a",
    hover: "Auto",
    active: "Auto",
    autoHover: "#e7eefd",
    autoActive: "#cedcfb",
    background: "#FFFFFF"
  },
  brandColor: {
    color: "#ffffff",
    hover: "Auto",
    active: "Auto",
    autoHover: "#4b7eee",
    autoActive: "#2055c9",
    background: "#2563eb"
  },
  launcherIcon: {
    size: 16,
    color: {
      color: "Auto",
      hover: "Auto",
      active: "Auto",
      background: "#1d4ed8"
    },
    opacity: 100
  },
  launcherButtons: {
    px: 16,
    height: 32,
    borderRadius: 8,
    primary: {
      border: {
        color: {
          color: "Auto",
          hover: "Auto",
          active: "Auto",
          background: "#FFFFFF"
        },
        enabled: false,
        borderWidth: 1
      },
      textColor: {
        color: "Auto",
        hover: "Auto",
        active: "Auto",
        background: "#FFFFFF"
      },
      fontWeight: 600,
      backgroundColor: {
        color: "#FFFFFF",
        hover: "Auto",
        active: "Auto",
        background: "Auto"
      }
    }
  },
  launcherBeacon: {
    size: 16,
    color: "#facc15"
  },
  checklistLauncher: {
    color: {
      color: "Auto",
      hover: "Auto",
      active: "Auto",
      background: "Auto"
    },
    height: 60,
    counter: {
      color: "Auto",
      background: "Auto"
    },
    placement: {
      position: "rightBottom",
      positionOffsetX: 100,
      positionOffsetY: 20
    },
    fontWeight: 600,
    borderRadius: 30
  },
  bubble: {
    width: 300,
    placement: {
      position: "leftBottom",
      positionOffsetX: 20,
      positionOffsetY: 20
    }
  },
  avatar: {
    type: AvatarType.CARTOON,
    size: 60,
    url: "",
    name: "alex"
  },
  resourceCenter: {
    placement: "bottom-right",
    offsetX: 20,
    offsetY: 20,
    normalWidth: 360,
    largeWidth: 480,
    maxHeight: 700,
    transitionDuration: 450,
    dividerLines: true,
    headerBackground: {
      type: "none",
      color: "Auto",
      gradientFrom: "Auto",
      gradientTo: "Auto",
      imageUrl: ""
    },
    logoUrl: ""
  },
  resourceCenterLauncherButton: {
    iconType: "default-question-mark",
    height: 60,
    imageHeight: 50,
    borderRadius: null,
    textMode: "no-text",
    color: {
      background: "Auto",
      hover: "Auto",
      active: "Auto",
      foreground: "Auto"
    }
  },
  resourceCenterUnreadBadge: {
    backgroundColor: "#ef4444",
    textColor: "#ffffff"
  },
  announcement: {
    bubbleWidth: 480,
    modalWidth: 600
  }
};
var standardDarkSettings = {
  font: {
    fontSize: 16,
    linkColor: "Auto",
    fontFamily: "System font",
    h1FontSize: 24,
    h2FontSize: 20,
    lineHeight: 24,
    fontWeightBold: 600,
    fontWeightNormal: 400
  },
  modal: {
    width: 600,
    padding: 40,
    backdropClickBehavior: ModalBackdropClickBehavior.DO_NOTHING
  },
  border: {
    borderColor: "Auto",
    borderWidth: 1,
    borderRadius: 10,
    borderWidthEnabled: false
  },
  survey: {
    color: "Auto"
  },
  buttons: {
    px: 16,
    height: 32,
    primary: {
      border: {
        color: {
          color: "Auto",
          hover: "Auto",
          active: "Auto",
          background: "#FFFFFF"
        },
        enabled: false,
        borderWidth: 1
      },
      textColor: {
        color: "Auto",
        hover: "Auto",
        active: "Auto",
        background: "#FFFFFF"
      },
      fontWeight: 600,
      backgroundColor: {
        color: "#FFFFFF",
        hover: "Auto",
        active: "Auto",
        background: "Auto"
      }
    },
    minWidth: 0,
    secondary: {
      border: {
        color: {
          color: "Auto",
          hover: "Auto",
          active: "Auto",
          background: "#FFFFFF"
        },
        enabled: true,
        borderWidth: 1
      },
      textColor: {
        color: "Auto",
        hover: "Auto",
        active: "Auto",
        background: "#FFFFFF"
      },
      fontWeight: 600,
      backgroundColor: {
        color: "#FFFFFF",
        hover: "Auto",
        active: "Auto",
        background: "Auto"
      }
    },
    borderRadius: 8
  },
  tooltip: {
    width: 300,
    notchSize: 20,
    missingTargetTolerance: 3,
    missingTargetBehavior: MissingTooltipTargetBehavior.AUTO_DISMISS
  },
  xbutton: {
    color: "Auto"
  },
  backdrop: {
    color: "#000000",
    opacity: 40,
    highlight: {
      type: "outside",
      color: "#ffffff",
      radius: 4,
      spread: 0,
      opacity: 50
    }
  },
  focusHighlight: {
    color: "Auto",
    opacity: 100
  },
  progress: {
    type: ProgressBarType.FULL_WIDTH,
    color: "Auto",
    height: 2,
    enabled: true,
    position: ProgressBarPosition.TOP,
    dotsHeight: 6,
    narrowHeight: 5,
    numberedHeight: 12,
    chainRoundedHeight: 6,
    chainSquaredHeight: 4
  },
  checklist: {
    width: 360,
    placement: {
      position: "rightBottom",
      positionOffsetX: 20,
      positionOffsetY: 20
    },
    checkmarkColor: "#4ade80",
    completedTaskTextDecoration: "line-through"
  },
  banner: {
    backgroundColor: {
      background: "Auto",
      color: "#FFFFFF",
      hover: "Auto",
      active: "Auto"
    },
    textColor: {
      background: "#FFFFFF",
      color: "Auto",
      hover: "Auto",
      active: "Auto"
    },
    padding: 8,
    animationDuration: 320,
    animationTiming: "smooth"
  },
  mainColor: {
    color: "#ffffff",
    hover: "Auto",
    active: "Auto",
    autoHover: "#142854",
    autoActive: "#19387f",
    background: "#0f172a"
  },
  brandColor: {
    color: "#ffffff",
    hover: "Auto",
    active: "Auto",
    autoHover: "#4b7eee",
    autoActive: "#2055c9",
    background: "#2563eb"
  },
  launcherIcon: {
    size: 16,
    color: {
      color: "Auto",
      hover: "Auto",
      active: "Auto",
      background: "#1d4ed8"
    },
    opacity: 100
  },
  launcherButtons: {
    px: 16,
    height: 32,
    borderRadius: 8,
    primary: {
      border: {
        color: {
          color: "Auto",
          hover: "Auto",
          active: "Auto",
          background: "#FFFFFF"
        },
        enabled: false,
        borderWidth: 1
      },
      textColor: {
        color: "Auto",
        hover: "Auto",
        active: "Auto",
        background: "#FFFFFF"
      },
      fontWeight: 600,
      backgroundColor: {
        color: "#FFFFFF",
        hover: "Auto",
        active: "Auto",
        background: "Auto"
      }
    }
  },
  launcherBeacon: {
    size: 16,
    color: "#facc15"
  },
  checklistLauncher: {
    color: {
      color: "Auto",
      hover: "Auto",
      active: "Auto",
      background: "Auto"
    },
    height: 60,
    counter: {
      color: "Auto",
      background: "Auto"
    },
    placement: {
      position: "rightBottom",
      positionOffsetX: 100,
      positionOffsetY: 20
    },
    fontWeight: 600,
    borderRadius: 30
  },
  bubble: {
    width: 300,
    placement: {
      position: "leftBottom",
      positionOffsetX: 20,
      positionOffsetY: 20
    }
  },
  avatar: {
    type: AvatarType.CARTOON,
    size: 60,
    url: "",
    name: "alex"
  },
  resourceCenter: {
    placement: "bottom-right",
    offsetX: 20,
    offsetY: 20,
    normalWidth: 360,
    largeWidth: 480,
    maxHeight: 700,
    transitionDuration: 450,
    dividerLines: true,
    headerBackground: {
      type: "none",
      color: "Auto",
      gradientFrom: "Auto",
      gradientTo: "Auto",
      imageUrl: ""
    },
    logoUrl: ""
  },
  resourceCenterLauncherButton: {
    iconType: "default-question-mark",
    height: 60,
    imageHeight: 50,
    borderRadius: null,
    textMode: "no-text",
    color: {
      background: "Auto",
      hover: "Auto",
      active: "Auto",
      foreground: "Auto"
    }
  },
  resourceCenterUnreadBadge: {
    backgroundColor: "#ef4444",
    textColor: "#ffffff"
  },
  announcement: {
    bubbleWidth: 480,
    modalWidth: 600
  }
};

// src/constants/attribute.ts
import { EventAttributes as EventAttributes2 } from "@usertour/types";
var trackerSystemMetadataAttributes = [
  EventAttributes2.EVENT_TRACKER_ID,
  EventAttributes2.EVENT_TRACKER_NAME,
  EventAttributes2.EVENT_TRACKER_VERSION_ID,
  EventAttributes2.EVENT_TRACKER_VERSION_NUMBER
];
var systemClientContextAttributes = [
  EventAttributes2.PAGE_URL,
  EventAttributes2.VIEWPORT_WIDTH,
  EventAttributes2.VIEWPORT_HEIGHT
];
var trackerSystemReservedEventAttributes = [
  ...trackerSystemMetadataAttributes,
  ...systemClientContextAttributes
];
var RANDOM_AB_VALUES = ["A", "B"];
var RANDOM_NUMBER_RANGE_MIN = 2;
var RANDOM_NUMBER_RANGE_MAX = 1e4;

// src/constants/banner.ts
import { BannerEmbedPlacement } from "@usertour/types";
var BANNER_EMBED_PLACEMENTS_REQUIRING_ELEMENT = [
  BannerEmbedPlacement.TOP_OF_CONTAINER_ELEMENT,
  BannerEmbedPlacement.BOTTOM_OF_CONTAINER_ELEMENT,
  BannerEmbedPlacement.IMMEDIATELY_BEFORE_ELEMENT,
  BannerEmbedPlacement.IMMEDIATELY_AFTER_ELEMENT
];
var DEFAULT_BANNER_DATA = {
  embedPlacement: BannerEmbedPlacement.TOP_OF_PAGE,
  overlayEmbedOverAppContent: false,
  stickToTopOfViewport: false,
  allowUsersToDismissEmbed: true,
  animateWhenEmbedAppears: true
};

// src/constants/button.ts
var BUTTON_VARIANT_MAP = {
  default: {
    primary: "default",
    secondary: "secondary"
  },
  banner: {
    primary: "banner-primary",
    secondary: "banner-secondary"
  }
};
var DEFAULT_BUTTON_SEMANTIC_TYPE = "primary";

// src/constants/checklist.ts
import { ChecklistCompletionOrder, ChecklistInitialDisplay } from "@usertour/types";
var DEFAULT_CHECKLIST_DATA = {
  buttonText: "Get Started",
  initialDisplay: ChecklistInitialDisplay.EXPANDED,
  completionOrder: ChecklistCompletionOrder.ANY,
  preventDismissChecklist: false,
  autoDismissChecklist: false,
  items: [],
  content: []
};

// src/constants/launcher.ts
import {
  LauncherActionType,
  LauncherDataType,
  LauncherIconSource,
  LauncherPositionType,
  LauncherTriggerElement,
  LauncherTriggerEvent
} from "@usertour/types";
var DEFAULT_LAUNCHER_DATA = {
  type: LauncherDataType.ICON,
  iconType: "user",
  iconSource: LauncherIconSource.BUILTIN,
  target: {
    element: void 0,
    screenshot: void 0,
    alignment: {
      side: "top",
      align: "center",
      alignType: "auto",
      sideOffset: 0,
      alignOffset: 0
    }
  },
  tooltip: {
    reference: LauncherPositionType.TARGET,
    element: void 0,
    alignment: {
      side: "top",
      align: "center",
      alignType: "auto",
      sideOffset: 0,
      alignOffset: 0
    },
    content: [],
    width: 250,
    settings: {
      dismissAfterFirstActivation: false,
      keepTooltipOpenWhenHovered: false,
      hideLauncherWhenTooltipIsDisplayed: false
    }
  },
  behavior: {
    triggerElement: LauncherTriggerElement.LAUNCHER,
    actionType: LauncherActionType.SHOW_TOOLTIP,
    triggerEvent: LauncherTriggerEvent.CLICKED,
    actions: []
  }
};

// src/constants/builtin-launcher-icons.ts
var BuiltinLauncherIcon = /* @__PURE__ */ ((BuiltinLauncherIcon2) => {
  BuiltinLauncherIcon2["AddLine"] = "add-line";
  BuiltinLauncherIcon2["ArrowDownCircleLine"] = "arrow-down-circle-line";
  BuiltinLauncherIcon2["ArrowDownLine"] = "arrow-down-line";
  BuiltinLauncherIcon2["ArrowLeftCircleLine"] = "arrow-left-circle-line";
  BuiltinLauncherIcon2["ArrowLeftLine"] = "arrow-left-line";
  BuiltinLauncherIcon2["ArrowRightCircleFill"] = "arrow-right-circle-fill";
  BuiltinLauncherIcon2["ArrowRightCircleLine"] = "arrow-right-circle-line";
  BuiltinLauncherIcon2["ArrowRightLine"] = "arrow-right-line";
  BuiltinLauncherIcon2["ArrowRightSLine"] = "arrow-right-s-line";
  BuiltinLauncherIcon2["ArrowUpCircleLine"] = "arrow-up-circle-line";
  BuiltinLauncherIcon2["ArrowUpLine"] = "arrow-up-line";
  BuiltinLauncherIcon2["AwardFill"] = "award-fill";
  BuiltinLauncherIcon2["AwardLine"] = "award-line";
  BuiltinLauncherIcon2["BannerIcon"] = "banner-icon";
  BuiltinLauncherIcon2["BatteryChargeLine"] = "battery-charge-line";
  BuiltinLauncherIcon2["BatteryLine"] = "battery-line";
  BuiltinLauncherIcon2["BluetoothLine"] = "bluetooth-line";
  BuiltinLauncherIcon2["BookLine"] = "book-line";
  BuiltinLauncherIcon2["BookOpenFill"] = "book-open-fill";
  BuiltinLauncherIcon2["BookmarkFill"] = "bookmark-fill";
  BuiltinLauncherIcon2["BookmarkLine"] = "bookmark-line";
  BuiltinLauncherIcon2["BrushLine"] = "brush-line";
  BuiltinLauncherIcon2["BugLine"] = "bug-line";
  BuiltinLauncherIcon2["CalendarLine"] = "calendar-line";
  BuiltinLauncherIcon2["ChatFill"] = "chat-fill";
  BuiltinLauncherIcon2["ChatLine"] = "chat-line";
  BuiltinLauncherIcon2["Chat1Fill"] = "chat1-fill";
  BuiltinLauncherIcon2["Chat1Line"] = "chat1-line";
  BuiltinLauncherIcon2["CheckCircleLine"] = "check-circle-line";
  BuiltinLauncherIcon2["CheckLine"] = "check-line";
  BuiltinLauncherIcon2["CheckboxCircleFill"] = "checkbox-circle-fill";
  BuiltinLauncherIcon2["CheckboxCircleLine"] = "checkbox-circle-line";
  BuiltinLauncherIcon2["CheckboxFill"] = "checkbox-fill";
  BuiltinLauncherIcon2["CheckboxLine"] = "checkbox-line";
  BuiltinLauncherIcon2["ChecklistIcon"] = "checklist-icon";
  BuiltinLauncherIcon2["CircleFill"] = "circle-fill";
  BuiltinLauncherIcon2["CircleLine"] = "circle-line";
  BuiltinLauncherIcon2["ClipboardFill"] = "clipboard-fill";
  BuiltinLauncherIcon2["ClipboardLine"] = "clipboard-line";
  BuiltinLauncherIcon2["CloseCircleLine"] = "close-circle-line";
  BuiltinLauncherIcon2["CloseLine"] = "close-line";
  BuiltinLauncherIcon2["CloudFill"] = "cloud-fill";
  BuiltinLauncherIcon2["CloudLine"] = "cloud-line";
  BuiltinLauncherIcon2["CompassFill"] = "compass-fill";
  BuiltinLauncherIcon2["CompassLine"] = "compass-line";
  BuiltinLauncherIcon2["CropLine"] = "crop-line";
  BuiltinLauncherIcon2["CrownFill"] = "crown-fill";
  BuiltinLauncherIcon2["CrownLine"] = "crown-line";
  BuiltinLauncherIcon2["DatabaseFill"] = "database-fill";
  BuiltinLauncherIcon2["DatabaseLine"] = "database-line";
  BuiltinLauncherIcon2["DeleteBinLine"] = "delete-bin-line";
  BuiltinLauncherIcon2["DeleteLine"] = "delete-line";
  BuiltinLauncherIcon2["DownloadLine"] = "download-line";
  BuiltinLauncherIcon2["EditLine"] = "edit-line";
  BuiltinLauncherIcon2["EqualizerLine"] = "equalizer-line";
  BuiltinLauncherIcon2["EraserLine"] = "eraser-line";
  BuiltinLauncherIcon2["ErrorWarningLine"] = "error-warning-line";
  BuiltinLauncherIcon2["EyeLine"] = "eye-line";
  BuiltinLauncherIcon2["EyeOffLine"] = "eye-off-line";
  BuiltinLauncherIcon2["FileCopyFill"] = "file-copy-fill";
  BuiltinLauncherIcon2["FileCopyLine"] = "file-copy-line";
  BuiltinLauncherIcon2["FileLine"] = "file-line";
  BuiltinLauncherIcon2["FileTextFill"] = "file-text-fill";
  BuiltinLauncherIcon2["FileTextLine"] = "file-text-line";
  BuiltinLauncherIcon2["FilterLine"] = "filter-line";
  BuiltinLauncherIcon2["FlagFill"] = "flag-fill";
  BuiltinLauncherIcon2["FlagLine"] = "flag-line";
  BuiltinLauncherIcon2["FlashlightLine"] = "flashlight-line";
  BuiltinLauncherIcon2["FlowIcon"] = "flow-icon";
  BuiltinLauncherIcon2["FocusLine"] = "focus-line";
  BuiltinLauncherIcon2["FolderLine"] = "folder-line";
  BuiltinLauncherIcon2["FullscreenExitLine"] = "fullscreen-exit-line";
  BuiltinLauncherIcon2["FullscreenLine"] = "fullscreen-line";
  BuiltinLauncherIcon2["GiftFill"] = "gift-fill";
  BuiltinLauncherIcon2["GiftLine"] = "gift-line";
  BuiltinLauncherIcon2["GlobalLine"] = "global-line";
  BuiltinLauncherIcon2["GridFill"] = "grid-fill";
  BuiltinLauncherIcon2["GridLine"] = "grid-line";
  BuiltinLauncherIcon2["HeartFill"] = "heart-fill";
  BuiltinLauncherIcon2["HeartLine"] = "heart-line";
  BuiltinLauncherIcon2["HomeFill"] = "home-fill";
  BuiltinLauncherIcon2["HomeLine"] = "home-line";
  BuiltinLauncherIcon2["ImageLine"] = "image-line";
  BuiltinLauncherIcon2["InfoCircled"] = "info-circled";
  BuiltinLauncherIcon2["InformationFill"] = "information-fill";
  BuiltinLauncherIcon2["KeyboardLine"] = "keyboard-line";
  BuiltinLauncherIcon2["LauncherIcon"] = "launcher-icon";
  BuiltinLauncherIcon2["Link"] = "link";
  BuiltinLauncherIcon2["LinkUnlink"] = "link-unlink";
  BuiltinLauncherIcon2["ListCheck"] = "list-check";
  BuiltinLauncherIcon2["ListCheck3"] = "list-check3";
  BuiltinLauncherIcon2["LockLine"] = "lock-line";
  BuiltinLauncherIcon2["LockUnlockLine"] = "lock-unlock-line";
  BuiltinLauncherIcon2["MailLine"] = "mail-line";
  BuiltinLauncherIcon2["MapFill"] = "map-fill";
  BuiltinLauncherIcon2["MapLine"] = "map-line";
  BuiltinLauncherIcon2["MapPinFill"] = "map-pin-fill";
  BuiltinLauncherIcon2["MapPinLine"] = "map-pin-line";
  BuiltinLauncherIcon2["MedalFill"] = "medal-fill";
  BuiltinLauncherIcon2["MedalLine"] = "medal-line";
  BuiltinLauncherIcon2["MenuLine"] = "menu-line";
  BuiltinLauncherIcon2["Message3Fill"] = "message3-fill";
  BuiltinLauncherIcon2["MoreLine"] = "more-line";
  BuiltinLauncherIcon2["MusicLine"] = "music-line";
  BuiltinLauncherIcon2["NavigationFill"] = "navigation-fill";
  BuiltinLauncherIcon2["NavigationLine"] = "navigation-line";
  BuiltinLauncherIcon2["NotificationFill"] = "notification-fill";
  BuiltinLauncherIcon2["NotificationLine"] = "notification-line";
  BuiltinLauncherIcon2["PagesFill"] = "pages-fill";
  BuiltinLauncherIcon2["PaintBrushLine"] = "paint-brush-line";
  BuiltinLauncherIcon2["PaletteLine"] = "palette-line";
  BuiltinLauncherIcon2["PauseLine"] = "pause-line";
  BuiltinLauncherIcon2["PhoneLine"] = "phone-line";
  BuiltinLauncherIcon2["PlayLine"] = "play-line";
  BuiltinLauncherIcon2["PlayListAddLine"] = "play-list-add-line";
  BuiltinLauncherIcon2["PlayListLine"] = "play-list-line";
  BuiltinLauncherIcon2["PriceTagFill"] = "price-tag-fill";
  BuiltinLauncherIcon2["PriceTagLine"] = "price-tag-line";
  BuiltinLauncherIcon2["QuestionLine"] = "question-line";
  BuiltinLauncherIcon2["RadioFill"] = "radio-fill";
  BuiltinLauncherIcon2["RadioLine"] = "radio-line";
  BuiltinLauncherIcon2["Radio2Fill"] = "radio2-fill";
  BuiltinLauncherIcon2["Radio2Line"] = "radio2-line";
  BuiltinLauncherIcon2["RecordCircleLine"] = "record-circle-line";
  BuiltinLauncherIcon2["RefreshLine"] = "refresh-line";
  BuiltinLauncherIcon2["RepeatLine"] = "repeat-line";
  BuiltinLauncherIcon2["ReplyLine"] = "reply-line";
  BuiltinLauncherIcon2["ResourceCenterIcon"] = "resource-center-icon";
  BuiltinLauncherIcon2["RestartLine"] = "restart-line";
  BuiltinLauncherIcon2["Rocket"] = "rocket";
  BuiltinLauncherIcon2["SaveFill"] = "save-fill";
  BuiltinLauncherIcon2["SaveLine"] = "save-line";
  BuiltinLauncherIcon2["Save2Fill"] = "save2-fill";
  BuiltinLauncherIcon2["Save2Line"] = "save2-line";
  BuiltinLauncherIcon2["ScissorsLine"] = "scissors-line";
  BuiltinLauncherIcon2["SearchFill"] = "search-fill";
  BuiltinLauncherIcon2["SearchLine"] = "search-line";
  BuiltinLauncherIcon2["SendInsFill"] = "send-ins-fill";
  BuiltinLauncherIcon2["SendInsLine"] = "send-ins-line";
  BuiltinLauncherIcon2["SendLine"] = "send-line";
  BuiltinLauncherIcon2["SendPlaneLine"] = "send-plane-line";
  BuiltinLauncherIcon2["Separator"] = "separator";
  BuiltinLauncherIcon2["ServerFill"] = "server-fill";
  BuiltinLauncherIcon2["ServerLine"] = "server-line";
  BuiltinLauncherIcon2["SettingsFill"] = "settings-fill";
  BuiltinLauncherIcon2["SettingsLine"] = "settings-line";
  BuiltinLauncherIcon2["ShareLine"] = "share-line";
  BuiltinLauncherIcon2["ShoppingBagFill"] = "shopping-bag-fill";
  BuiltinLauncherIcon2["ShoppingBagLine"] = "shopping-bag-line";
  BuiltinLauncherIcon2["ShoppingCartFill"] = "shopping-cart-fill";
  BuiltinLauncherIcon2["ShoppingCartLine"] = "shopping-cart-line";
  BuiltinLauncherIcon2["ShuffleLine"] = "shuffle-line";
  BuiltinLauncherIcon2["ShutDownLine"] = "shut-down-line";
  BuiltinLauncherIcon2["SkipBackLine"] = "skip-back-line";
  BuiltinLauncherIcon2["SkipForwardLine"] = "skip-forward-line";
  BuiltinLauncherIcon2["SquareFill"] = "square-fill";
  BuiltinLauncherIcon2["SquareLine"] = "square-line";
  BuiltinLauncherIcon2["StarFill"] = "star-fill";
  BuiltinLauncherIcon2["StarLine"] = "star-line";
  BuiltinLauncherIcon2["StopLine"] = "stop-line";
  BuiltinLauncherIcon2["StoreFill"] = "store-fill";
  BuiltinLauncherIcon2["StoreLine"] = "store-line";
  BuiltinLauncherIcon2["SubtractLine"] = "subtract-line";
  BuiltinLauncherIcon2["ThumbDownLine"] = "thumb-down-line";
  BuiltinLauncherIcon2["ThumbUpLine"] = "thumb-up-line";
  BuiltinLauncherIcon2["TimeLine"] = "time-line";
  BuiltinLauncherIcon2["TriangleFill"] = "triangle-fill";
  BuiltinLauncherIcon2["TriangleLine"] = "triangle-line";
  BuiltinLauncherIcon2["TrophyFill"] = "trophy-fill";
  BuiltinLauncherIcon2["TrophyLine"] = "trophy-line";
  BuiltinLauncherIcon2["UploadLine"] = "upload-line";
  BuiltinLauncherIcon2["User"] = "user";
  BuiltinLauncherIcon2["UserLine"] = "user-line";
  BuiltinLauncherIcon2["VideoLine"] = "video-line";
  BuiltinLauncherIcon2["VipCrown2Fill"] = "vip-crown2-fill";
  BuiltinLauncherIcon2["VipCrown2Line"] = "vip-crown2-line";
  BuiltinLauncherIcon2["VolumeDownLine"] = "volume-down-line";
  BuiltinLauncherIcon2["VolumeMuteLine"] = "volume-mute-line";
  BuiltinLauncherIcon2["VolumeUpLine"] = "volume-up-line";
  BuiltinLauncherIcon2["WifiLine"] = "wifi-line";
  BuiltinLauncherIcon2["WifiOffLine"] = "wifi-off-line";
  BuiltinLauncherIcon2["ZoomInLine"] = "zoom-in-line";
  BuiltinLauncherIcon2["ZoomOutLine"] = "zoom-out-line";
  return BuiltinLauncherIcon2;
})(BuiltinLauncherIcon || {});
var BUILTIN_LAUNCHER_ICON_NAMES = Object.values(BuiltinLauncherIcon);

// src/constants/content-editor-path.ts
import { ContentDataType } from "@usertour/types";
var CONTENT_TYPE_PATH_SEGMENT = {
  [ContentDataType.FLOW]: "flows",
  [ContentDataType.CHECKLIST]: "checklists",
  [ContentDataType.LAUNCHER]: "launchers",
  [ContentDataType.BANNER]: "banners",
  [ContentDataType.TRACKER]: "trackers",
  [ContentDataType.RESOURCE_CENTER]: "resource-centers",
  [ContentDataType.ANNOUNCEMENT]: "announcements"
};

// src/constants/resource-center.ts
var DEFAULT_RESOURCE_CENTER_DATA = {
  buttonText: "Help",
  headerText: "Resource Center",
  tabs: []
};

// src/constants/webhook.ts
import { BizEvents as BizEvents2 } from "@usertour/types";
var WEBHOOK_NOISY_EVENTS = [BizEvents2.PAGE_VIEWED];
var WEBHOOK_EVENT_TOPIC_PREFIX = "event.tracked";
var WEBHOOK_CONTENT_PUBLISHED_TOPIC = "content.published";
var WEBHOOK_ENTITY_TOPICS = [
  "user.created",
  "user.updated",
  "user.deleted",
  "company.created",
  "company.updated",
  "company.deleted"
];
var WEBHOOK_CONFIG_TOPICS = [
  WEBHOOK_CONTENT_PUBLISHED_TOPIC,
  ...WEBHOOK_ENTITY_TOPICS
];
var WEBHOOK_PREFIX_SUBSCRIPTIONS = [
  WEBHOOK_EVENT_TOPIC_PREFIX,
  "content",
  "user",
  "company"
];
var MAX_TOPIC_SUBSCRIPTIONS = 100;
var WEBHOOK_TOPIC_WILDCARD = "*";
var WEBHOOK_TEST_TOPIC = "webhook.test";

// src/constants/integration.ts
import {
  AttributeDataType as AttributeDataType2
} from "@usertour/types";
import { BizEvents as BizEvents3 } from "@usertour/types";
var INTEGRATION_PROVIDERS = [
  "amplitude",
  "heap",
  "mixpanel",
  "posthog",
  "segment"
];
var CRM_INTEGRATION_PROVIDERS = ["hubspot"];
var INTEGRATION_TEST_TOPIC = "integration.test";
var SYNC_REMOTE_PROPERTY_GROUP = { name: "usertour", label: "Usertour" };
var remotePropertyNameFor = (local, codeName) => `usertour_${local}_${codeName.toLowerCase()}`;
var localDataTypeFor = (property) => {
  switch (property.type) {
    case "number":
      return AttributeDataType2.Number;
    case "bool":
      return AttributeDataType2.Boolean;
    case "date":
    case "datetime":
      return AttributeDataType2.DateTime;
    case "enumeration":
      return property.fieldType === "checkbox" ? AttributeDataType2.List : AttributeDataType2.String;
    default:
      return AttributeDataType2.String;
  }
};
var SYNC_ROUND_STALE_MS = 13 * 60 * 60 * 1e3;
var SYNC_TIMELINE_EVENTS = [
  BizEvents3.FLOW_STARTED,
  BizEvents3.FLOW_COMPLETED,
  BizEvents3.FLOW_ENDED,
  BizEvents3.CHECKLIST_STARTED,
  BizEvents3.CHECKLIST_COMPLETED,
  BizEvents3.CHECKLIST_TASK_COMPLETED,
  BizEvents3.QUESTION_ANSWERED,
  BizEvents3.LAUNCHER_ACTIVATED
];
export {
  ACCESS_TOKEN_COOKIE,
  ANNOUNCEMENT_FEED_SCAN_LIMIT,
  ANNOUNCEMENT_SEEN_SOURCES,
  BANNER_EMBED_PLACEMENTS_REQUIRING_ELEMENT,
  BUILDER_Z,
  BUILTIN_LAUNCHER_ICON_NAMES,
  BUTTON_VARIANT_MAP,
  BuiltinLauncherIcon,
  BusinessSessionLimit,
  CONTENT_TYPE_PATH_SEGMENT,
  CRM_INTEGRATION_PROVIDERS,
  DEFAULT_ANNOUNCEMENT_DATA,
  DEFAULT_BANNER_DATA,
  DEFAULT_BUTTON_SEMANTIC_TYPE,
  DEFAULT_CHECKLIST_DATA,
  DEFAULT_LAUNCHER_DATA,
  DEFAULT_POPUP_CONFIG,
  DEFAULT_RESOURCE_CENTER_DATA,
  EDITOR_OVERLAY,
  EDITOR_RICH_ACTION,
  EDITOR_RICH_ACTION_CONTENT,
  EDITOR_RICH_TOOLBAR,
  EDITOR_RICH_TOOLBAR_MORE,
  EDITOR_SELECT,
  EDITOR_SIDEBAR,
  GrowthSessionLimit,
  HobbySessionLimit,
  INTEGRATION_CATALOG,
  INTEGRATION_PROVIDERS,
  INTEGRATION_TEST_TOPIC,
  LICENSE_FEATURE_TWO_FACTOR,
  MACHINE_TRANSLATION_UNITS_PER_BATCH,
  MAX_TOPIC_SUBSCRIPTIONS,
  MAX_WAIT_SECONDS,
  MESSAGE_APPLICATION_CLOSE,
  MESSAGE_APPLICATION_EXIT,
  MESSAGE_APPLICATION_INIT,
  MESSAGE_APPLICATION_INIT_SUCCESS,
  MESSAGE_APPLICATION_RUN,
  MESSAGE_APPLICATION_STARTED,
  MESSAGE_CONTENT_PREVIEW,
  MESSAGE_CONTENT_PREVIEW_SUCCESS,
  MESSAGE_CRX_OPEN_NEW_TARGET,
  MESSAGE_CRX_OPEN_TARGET,
  MESSAGE_CRX_OPEN_TARGET_REPLY,
  MESSAGE_CRX_PING,
  MESSAGE_CRX_PONG,
  MESSAGE_CRX_SEND_PROXY,
  MESSAGE_ELEMENT_SELECT_SUCCESS,
  MESSAGE_IFRAME_CONTAINER_STYLE,
  MESSAGE_MEASURE_INSTALL,
  MESSAGE_MEASURE_LISTENER,
  MESSAGE_SDK_INIT,
  MESSAGE_SELECTOR_OUTPUT,
  MESSAGE_SELECTOR_SWITCH,
  MESSAGE_START_FLOW_WITH_TOKEN,
  PLAN_FEATURES,
  PREVIEW_BASIC,
  ProSessionLimit,
  RANDOM_AB_VALUES,
  RANDOM_NUMBER_RANGE_MAX,
  RANDOM_NUMBER_RANGE_MIN,
  REFRESH_TOKEN_COOKIE,
  ROLE_CAPABILITIES,
  RulesZIndexOffset,
  SDKClientEvents,
  SYNC_INTEGRATION_PROVIDERS,
  SYNC_REMOTE_PROPERTY_GROUP,
  SYNC_ROUND_STALE_MS,
  SYNC_TIMELINE_EVENTS,
  StorageKeys,
  TAILWINDCSS_COLORS,
  THEME_SETTING_CONSTRAINTS,
  UID_COOKIE,
  WEBHOOK_CONFIG_TOPICS,
  WEBHOOK_CONTENT_PUBLISHED_TOPIC,
  WEBHOOK_ENTITY_TOPICS,
  WEBHOOK_EVENT_TOPIC_PREFIX,
  WEBHOOK_NOISY_EVENTS,
  WEBHOOK_PREFIX_SUBSCRIPTIONS,
  WEBHOOK_TEST_TOPIC,
  WEBHOOK_TOPIC_WILDCARD,
  WEBSOCKET_NAMESPACES_V2,
  WebZIndex,
  WidgetZIndex,
  catalogEntryForSource,
  defaultAttributes,
  defaultEvents,
  defaultSettings,
  flowReasonTitleMap,
  localDataTypeFor,
  locates,
  remotePropertyNameFor,
  roleCan,
  standardDarkSettings,
  systemClientContextAttributes,
  trackerSystemMetadataAttributes,
  trackerSystemReservedEventAttributes
};
